import { UserService } from './../../user.service';
import {
  BaseFormComponent,
  BaseFormHeaderInfo
} from '../../tasks/baseFormComponent/baseForm.component';
import {
  Component,
  OnInit,
  Optional,
  ElementRef,
  Input,
  AfterContentInit,
  OnDestroy
} from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import {
  ProjectEntityDTO,
  AccountingDocumentDTO,
  CompanyDocDTO,
  ExpenseDocumentInvoiceAssociationDTO,
  AwardDTO, CompanyDTO, AddressDTO, ActionParameterDefinitionDTO, InvoiceDetailLineDTO, ProcedureActionDossierDTO, ActionResultDTO,
  BudgetAccountLineDTO, BudgetAccountLineInvoiceAssociationDTO, BudgetAccountLineInvoiceDiscountAssociationDTO, InvoiceDTO, ExpenseManagementLineDTO, ExpenseTaskStates
} from '../../api/plyca-dtos-v2';
import {
  DocumentFileTypeDTO, FileDetailsDTO, TaskDTO, getSimpleIdentifierFromString,
  getParentIdentifierFromString, DocumentDTO, RelatedDocumentDTO, MasterDataDTO, SearchSelectionResultDTO, LinkedActionsDTO,
  ActionDTO, ActionParameterDTO, DocumentVersionDTO
} from '../../api/plyca-dtos';

import { TranslateService } from '@ngx-translate/core';
import { EMPTY, Observable, of, throwError } from 'rxjs';
import { generateRandomIdentifier, UIService } from '../../ui.service';
import { FormConfig, FunctionDef } from '../../components/forms/form.objects';
import * as lodash from 'lodash';
import { SearchSettingDTOModal, searchGenericComponent } from '../../components/search/searchGeneric.component';
import { map, catchError, finalize, take, tap, switchMap } from 'rxjs/operators';
import {
  HelpType
} from '../../components/common/help/help.service';

import { HelpService } from '../../components/common/help/help.service';
import { tableComponent } from '../../main-view/table.component';
import { AppConfiguration } from '../../conf/app.configuration';
import { PaginationDTO } from '../../api/PaginationModel';
import { PlycaErrorHandler } from '../../../http/PlycaErrorHandler';
import { DialogService, DynamicDialogConfig, DynamicDialogRef } from 'primeng-lts/dynamicdialog';
import { ActionsProcessComponent } from '../../actions/actions.process.component';
import { DocumentFilesListComponent } from '../../documents/documentFilesList/documentFilesList.component';
import { FieldAction } from '../../api/contract-notice-dto';

export class AccountingDocumentModel {

  dto: AccountingDocumentDTO;
  ui: {
    'award'?: AwardDTO,
    'docDivisionId'?: string,
    'awardDivisionId'?: string,
    'dossierId'?: string,
    'sign'?: string,
    'companyInterested'?: CompanyDTO,
    'companyAssignee'?: CompanyDTO,
    'companyBeneficiary'?: CompanyDTO,
    'isFaseRC'?: boolean,
    'isFaseA'?: boolean,
    'isFaseD'?: boolean,
    'isFaseO'?: boolean,
    'isFaseK'?: boolean,
    'isAssociateDocsAccionTask'?: boolean,
    'isPostingAccionTask'?: boolean,
    'isValidateAccionTask'?: boolean,
    'isDataAccionTask'?: boolean,
    'isEditableActionDescription'?: boolean,
    'isEditableProcedureDescription'?: boolean,
    'notVisibleRelatedDocuments'?: Array<RelatedDocumentDTO>,
    'visibleRelatedDocuments'?: Array<RelatedDocumentDTO>,
    'isSupportProfile'?: boolean,
    // CIXTEC
    'procedureActionDossier_typeDossier_SearchGenericResult'?: SearchSelectionResultDTO,
    'procedureActionDossier_typeAction_SearchGenericResult'?: SearchSelectionResultDTO,
    'procedureActionDossier_typeProcedure_SearchGenericResult'?: SearchSelectionResultDTO,
    // AYMAD
    'integrationExpenseDocument'?: AccountingDocumentDTO,
    'societyIdentifier'?: string,
    'integrationNITCompanyDocInterested'?: CompanyDocDTO;
    'budgetAccountLineInvoiceAssociates'?: Array<BudgetAccountLineInvoiceAssociationDTO>;
    'budgetAccountLineInvoiceDiscountAssociates'?: Array<BudgetAccountLineInvoiceDiscountAssociationDTO>;

    // TOTALES
    'totalAmountBudget'?: number;
    'totalAmountInvoices'?: number;
    'totalAmountDiscounts'?: number;
    'liquidAmount'?: number;

    'readonlyModeInputActions'?: boolean;
  }
}

@Component({
  selector: 'accountingDocument-form',
  templateUrl: '../../tasks/baseFormComponent/baseForm.template.html',
  providers: [DialogService, UIService]
})
export class AccountingDocumentComponent
  extends BaseFormComponent<AccountingDocumentDTO, AccountingDocumentModel>
  implements OnInit, AfterContentInit, OnDestroy {

  private identifier: string;
  private expenseManagementLine: ExpenseManagementLineDTO;

  dossierId: any;
  divisionId: any;
  documentClassId: any;
  sign: any;
  documentType: any;
  exerciseClassification: string;

  parentDocumentIdentifier: any;
  isModal: Boolean;
  isworkExpenseDocument: Boolean;

  @Input()
  project: ProjectEntityDTO;
  windowHash: any;
  projectId: any;
  taskId: string;

  availableLinkedActions: LinkedActionsDTO;
  availableActions: Array<ActionDTO>;
  visibleAndAvailableActions: Array<ActionDTO>;
  loadedLazyActions = false;
  isDisabled = '';
  botoneraLoaded = false;
  readonlyModeInputActions = false;
  showDocument = false;


  private static isEditModeTable(model: any, withSign: boolean,): boolean {
    // Si funciona en las tablas!!
    // En el json se invoca a esta función de forma que:
    //      $functions.editModeTable
    // o
    //      !this.model._parent.ui.isAssociateDocsAccionTask && !this.model._parent.ui.isPostingAccionTask
    //      !$model._parent.ui.isAssociateDocsAccionTask && !$model._parent.ui.isPostingAccionTask
    // console.log('************************************INICIO-editModeTable functions*****************************************');
    let isEdit = !model._parent.ui.isAssociateDocsAccionTask && !model._parent.ui.isPostingAccionTask;
    if (withSign) {
      isEdit = isEdit && model._parent.dto.sign == 0;
    }
    // console.log('editModeTable functions : model._parent.ui.isAssociateDocsAccionTask,
    // model._parent.ui.isPostingAccionTask, isEdit : ', model._parent.ui.isAssociateDocsAccionTask,
    // model._parent.ui.isPostingAccionTask, isEdit);
    // console.log('******************************************FIN-editModeTable functions *****************************************');
    return isEdit;
  }
  private static isEditMode(model: any, withSign: boolean): boolean {
    // No funciona en las tablas!!
    // console.log('************************************INICIO-editMode functions*****************************************');
    let isEdit = !model.ui.isAssociateDocsAccionTask && !model.ui.isPostingAccionTask && !model.ui.isValidateAccionTask;
    if (withSign) {
      isEdit = isEdit && model.dto.sign == 0;
    }
    // console.log('editMode functions : model.ui.isAssociateDocsAccionTask, model.ui.isPostingAccionTask, isEdit :',
    // model.ui.isAssociateDocsAccionTask, model.ui.isPostingAccionTask, isEdit);
    // console.log('******************************************FIN-editMode functions *****************************************');
    return isEdit;
  }
  constructor(
    elem: ElementRef,
    public translationService: TranslateService,
    protected helpService: HelpService,
    protected appConfig: AppConfiguration,
    private plycaErrorHandler: PlycaErrorHandler,
    private userService: UserService,
    @Optional() public dialogConfig: DynamicDialogConfig,
    @Optional() public ref: DynamicDialogRef,
    @Optional() protected activatedRoute: ActivatedRoute
  ) {
    super(elem);
    activatedRoute.params.subscribe(params => {
      this.identifier = params['id'];
    });

    if (dialogConfig && JSON.stringify(dialogConfig) != '{}') {

      this.isModal = true;
      this.identifier = dialogConfig['id'];
      // this.expenseManagementTask = dialogConfig['task'];
      this.task = dialogConfig['task'];
      this.showDocument = dialogConfig['readOnly'];

      this.expenseManagementLine = dialogConfig['expenseManagementLine'];
      // this.expenseManagementTask = this.task;

      // Contexto de la tarea
      // if (this.expenseManagementTask && this.expenseManagementTask.work && this.expenseManagementTask.work.context) {
      //  let isMandatoryInvoice = this.expenseManagementTask.work.context.configurations['isMandatoryInvoice'];
      //  let accionTask = this.expenseManagementTask.work.context.configurations['accionTask']
      //  let existTemplate = this.expenseManagementTask.work.context.configurations['existTemplate']
      // }

      if (!this.identifier) {
        // PARAMETROS PARA USO DE LA INVOCACION A NEW EN MODO ALTA
        this.dossierId = dialogConfig['projectIdentifier'];
        this.divisionId = dialogConfig['divisionId'];
        this.documentClassId = dialogConfig['documentClassId'];
        this.exerciseClassification = dialogConfig['exerciseClassification'];
        this.sign = dialogConfig['sign'];
        if (this.task) {
          this.taskId = this.task.identifier;
        }
        if (dialogConfig['sign']) {
          this.sign = '1';
        } else {
          this.sign = '0';
        }
        this.documentType = dialogConfig['documentType'];
        this.parentDocumentIdentifier = dialogConfig['parentDocumentIdentifier'];
      }
    } else {
      // ELIMINAR SI FINALMENTE SOLO SE EDITA EN MODAL
      // this.activatedRoute.queryParams.subscribe(params => {
      //   this.dossierId = params['projectIdentifier'];
      //   this.divisionId = params['divisionId'];
      //   this.documentClassId = params['documentClassId'];
      //   if (params['sign']) {
      //     this.sign = '1';
      //   } else {
      //     this.sign = '0';
      //   }
      //   this.documentType = params['documentType'];
      // });
    }
  }

  ngOnDestroy() {
    this.dialogConfig = null;
    this.dialogService = null;
    if (this.isModal) {
      this.headerActionsService.clearWindowActions(this.windowHash);
    } else {
      this.headerActionsService.clearActions();
    }
    super.ngOnDestroy();
  }

  getObjectParams(): { [param: string]: string | string[] } {
    return {
      expand: 'expansionSet:work'
      // projectIdentifier: this.dossierId,
      // divisionId: this.divisionId,
      // taskId: this.taskId
      // documentClassId: this.documentClassId
    };
  }

  ngOnInit(): void {
    super.ngOnInit();
  }


  /* ngAfterContentInit(): void {

     //if (this.task && this.task.work && this.task.work.expenseDocument) {
     //  this.identifier = this.task.work.expenseDocument.identifier;
     //}
   }*/

  getFormSettingURL(): string {
    return 'accountingDocumentDTOInterfaceSettings.json';
  }

  getServiceURL(): string {
    return this.configuration.EXPENSE_DOCUMENT_SERVICE_URL;
  }

  getObjectIdentifier(): string {
    if (this.task && this.task.work && this.task.work.expenseDocument) {
      return undefined; // Para no consultar en servidor en baseform.ngOnInit()
    } else if (this.identifier != undefined) {
      return this.identifier;
    } else {
      return 'new?projectIdentifier=' + this.dossierId + '&divisionId=' + this.divisionId + '&documentClassId=' + this.documentClassId + '&sign=' + this.sign + '&documentType=' + encodeURIComponent(this.documentType) + '&exerciseClassification=' + this.exerciseClassification + '&parentDocumentIdentifier=' + this.parentDocumentIdentifier + '&taskId=' + this.taskId;
    }
  }

  dtoToModel(dto: AccountingDocumentDTO): Observable<AccountingDocumentModel> {
    // Cargamos pantalla!!
    let model = new AccountingDocumentModel();
    if (this.task && this.task.work && this.task.work.expenseDocument) {
      model.dto = this.task.work.expenseDocument;
    } else {
      model.dto = dto;
    }

    // Iniciamos el ui
    model.ui = {};

    model.ui.isEditableActionDescription = false;
    model.ui.isEditableProcedureDescription = false;
    model.ui.isSupportProfile = false;

    let supportProfile = this.appConfig.getValue('user.supportProfile');
    model.ui.isSupportProfile = this.userService.hasRoles(supportProfile);


    model.ui.readonlyModeInputActions = this.readonlyModeInputActions;

    if (model.dto != null) {
      this.initDraftFiles(model.dto); // temporales
      /* if (this.task && this.task.work && this.task.work.expenseDocument) {
          model.dto = this.task.work.expenseDocument;
        }*/


      model.ui.docDivisionId = getSimpleIdentifierFromString(model.dto.division.identifier);
      model.ui.dossierId = getParentIdentifierFromString(model.dto.division.identifier);

      // AYMAD
      if (model.dto.award?.division) {
        model.ui.awardDivisionId = getSimpleIdentifierFromString(model.dto.award.division.identifier);
      }

      if (model.dto.society && model.dto.society.identifier) {
        model.ui.societyIdentifier = getSimpleIdentifierFromString(model.dto.society.identifier);
      }
      if (model.dto.interested) {
        model.ui.integrationNITCompanyDocInterested = model.dto.interested;
      }

      if (model.dto.expenseDocumentType.sign === 0) {
        if (model.dto.expenseDocumentType.multipleSign) {
          model.ui.sign = '+/-';
        } else {
          model.ui.sign = '+';
        }
      } else {
        model.ui.sign = '-';
      }
      // FIN AYMAD

      model.ui.isAssociateDocsAccionTask = false;
      model.ui.isPostingAccionTask = false;
      model.ui.isDataAccionTask = false;
      model.ui.isValidateAccionTask = false;

      if (this.task && this.task.work && this.task.work.context && this.task.work.context.configurations
        && this.task.work.context.configurations['accionTask']) {
        if (this.task.work.context.configurations['accionTask'].value === '__DATOS_ASOC') {
          model.ui.isAssociateDocsAccionTask = true;
        } else if (this.task.work.context.configurations['accionTask'].value === '__DATOS' || this.task.work.context.configurations['accionTask'].value === '__REPARA') {
          model.ui.isDataAccionTask = true;
        } else if (this.task.work.context.configurations['accionTask'].value === '__DATOS_CONTAB' || this.task.work.context.configurations['isPostedTask'].value) {
          model.ui.isPostingAccionTask = true;
        } else if (this.task.work.context.configurations['accionTask'].value === '__VALIDA') {
          model.ui.isValidateAccionTask = true;
        }
      }
      let faseRC = model.dto.expensePhases.find(x => x.identifier.indexOf('RC') > -1);
      let faseA = model.dto.expensePhases.find(x => x.identifier.indexOf('A') > -1);
      let faseO = model.dto.expensePhases.find(x => x.identifier.indexOf('O') > -1);
      let faseD = model.dto.expensePhases.find(x => x.identifier.indexOf('D') > -1);
      let faseK = model.dto.expensePhases.find(x => x.identifier.indexOf('K') > -1);
      model.ui.isFaseRC = false;
      model.ui.isFaseA = false;
      model.ui.isFaseD = false;
      model.ui.isFaseO = false;
      model.ui.isFaseK = false;
      if (faseRC) {
        model.ui.isFaseRC = true;
      }
      if (faseA) {
        model.ui.isFaseA = true;
      }
      if (faseD) {
        model.ui.isFaseD = true;
      }
      if (faseO) {
        model.ui.isFaseO = true;
      }
      if (faseK) {
        model.ui.isFaseK = true;
      }

      model.ui.notVisibleRelatedDocuments = new Array<RelatedDocumentDTO>();
      model.ui.visibleRelatedDocuments = new Array<RelatedDocumentDTO>();
      if (model.dto.document && model.dto.document.relatedDocuments) {
        let relatedDocuments = model.dto.document.relatedDocuments;
        for (let i in relatedDocuments) {
          if (relatedDocuments[i]) {
            if (relatedDocuments[i].visible) {
              model.ui.visibleRelatedDocuments.push(relatedDocuments[i]);
            } else {
              model.ui.notVisibleRelatedDocuments.push(relatedDocuments[i]);
            }
          }
        }
      }

      // AYMAD ***************************************************************************************************
      // *************************************

      let cliente = this.appConfig.getValue('cliente');
      // TODO 'AYMAD'
      //cliente = 'AYMAD';
      if ('AYMAD' === cliente) {
        if (model.ui.isFaseO) {
          // PARTIDAS_ FACTURAS
          if (model.dto.budget && model.dto.budget.budgetAccountLine) {
            model.ui.budgetAccountLineInvoiceAssociates = new Array<BudgetAccountLineInvoiceAssociationDTO>();
            for (let i in dto.budget.budgetAccountLine) {
              if (dto.budget.budgetAccountLine[i].identifier == null) { // Con el == tb controlamos el undefined
                dto.budget.budgetAccountLine[i].identifier = this.generateNumber();
              }
              if (dto.budget.budgetAccountLine[i] && dto.budget.budgetAccountLine[i].budgetAccountLineInvoiceAssociates) {
                for (let j in dto.budget.budgetAccountLine[i].budgetAccountLineInvoiceAssociates) {
                  if (dto.budget.budgetAccountLine[i].budgetAccountLineInvoiceAssociates[j]) {
                    if (dto.budget.budgetAccountLine[i].budgetAccountLineInvoiceAssociates[j].identifier == null) {
                      dto.budget.budgetAccountLine[i].budgetAccountLineInvoiceAssociates[j].budgetAccountLine.identifier = dto.budget.budgetAccountLine[i].identifier;
                    }
                    model.ui.budgetAccountLineInvoiceAssociates.push(dto.budget.budgetAccountLine[i].budgetAccountLineInvoiceAssociates[j]);
                  }
                }
              }
            }

            //Ordenamos
            if (model.ui.budgetAccountLineInvoiceAssociates && model.ui.budgetAccountLineInvoiceAssociates.length > 0) {
              this.sortBudgetAccountLineInvoice(model.ui.budgetAccountLineInvoiceAssociates);
            }


          }
          // PARTIDAS_FATURAS_RETENCIONES
          if (model.ui.budgetAccountLineInvoiceAssociates) {
            model.ui.budgetAccountLineInvoiceDiscountAssociates = new Array<BudgetAccountLineInvoiceDiscountAssociationDTO>();
            for (let i in model.ui.budgetAccountLineInvoiceAssociates) {
              if (model.ui.budgetAccountLineInvoiceAssociates[i]
                && model.ui.budgetAccountLineInvoiceAssociates[i].budgetAccountLineInvoiceDiscountAssociates) {
                let budgetAccountLineInvoiceSelected = model.ui.budgetAccountLineInvoiceAssociates[i];
                let budgetAccountLineSelected = budgetAccountLineInvoiceSelected.budgetAccountLine;
                let invoiceDetailLineSelected = budgetAccountLineInvoiceSelected.invoiceDetailLine;
                for (let j in budgetAccountLineInvoiceSelected.budgetAccountLineInvoiceDiscountAssociates) {
                  if (budgetAccountLineInvoiceSelected.budgetAccountLineInvoiceDiscountAssociates[j]) {


                    let budgetAccountLineInvoiceDiscountSelected =
                      budgetAccountLineInvoiceSelected.budgetAccountLineInvoiceDiscountAssociates[j];

                    budgetAccountLineInvoiceDiscountSelected.invoice = budgetAccountLineInvoiceSelected.invoice;
                    budgetAccountLineInvoiceDiscountSelected.budgetAccountLine = budgetAccountLineSelected;
                    budgetAccountLineInvoiceDiscountSelected.invoiceDetailLine = invoiceDetailLineSelected
                    model.ui.budgetAccountLineInvoiceDiscountAssociates.push(budgetAccountLineInvoiceDiscountSelected);
                  }
                }
              }
            }

            //Ordenamos
            if (model.ui.budgetAccountLineInvoiceDiscountAssociates && model.ui.budgetAccountLineInvoiceDiscountAssociates.length > 0) {
              //this.sortBudgetAccountLineInvoiceDiscount(model.ui.budgetAccountLineInvoiceDiscountAssociates);
            }
          }
        }

        model.ui.totalAmountInvoices = this.getTotalAmountInvoices(model);
        model.ui.totalAmountDiscounts = this.getTotalAmountDiscounts(model);
        let liquidAmount = model.ui.totalAmountInvoices - model.ui.totalAmountDiscounts;
        model.ui.liquidAmount = this.roundDecimals(liquidAmount, 2);
      }

      // AYMAD ****************************************************************************************************************************************

      model.ui.totalAmountBudget = this.getTotalAmountBudget(model);

      /*
      image_array !== 'undefined' && image_array.length > 0
     function isBigEnough(element, index, array) {
     return (element >= 10);
     var passed = [12, 5, 8, 130, 44].filter(isBigEnough);
     */

      if (model.dto.award) {
        model.ui.award = model.dto.award;
      }
      if (model.dto.assignee) {
        if (!model.ui.companyAssignee) {
          model.ui.companyAssignee = new CompanyDTO();
        }
        if (model.dto.assignee.name) {
          model.ui.companyAssignee.name = model.dto.assignee.name;
        }
        if (model.dto.assignee.taxIdentifier) {
          model.ui.companyAssignee.taxIdentifier = model.dto.assignee.taxIdentifier;
        }
        if (model.dto.assignee.address && model.dto.assignee.address.name) {
          let addressassignee = new AddressDTO();
          let alladdressassignee: Array<AddressDTO> = [];
          addressassignee.name = model.dto.assignee.address.name;
          alladdressassignee[0] = addressassignee;
          model.ui.companyAssignee.addresses = alladdressassignee;
        }
      }
      if (model.dto.beneficiary) {
        if (!model.ui.companyBeneficiary) {
          model.ui.companyBeneficiary = new CompanyDTO();
        }
        if (model.dto.beneficiary.name) {
          model.ui.companyBeneficiary.name = model.dto.beneficiary.name;
        }
        if (model.dto.beneficiary.taxIdentifier) {
          model.ui.companyBeneficiary.taxIdentifier = model.dto.beneficiary.taxIdentifier;
        }
        if (model.dto.beneficiary.address && model.dto.beneficiary.address.name) {
          let addressbeneficiary = new AddressDTO();
          let alladdressbeneficiary: Array<AddressDTO> = [];
          addressbeneficiary.name = model.dto.beneficiary.address.name;
          alladdressbeneficiary[0] = addressbeneficiary;
          model.ui.companyBeneficiary.addresses = alladdressbeneficiary;
        }
      }
      if (model.dto.procedureActionDossier && model.dto.procedureActionDossier.typeDossierId) {

        model.ui.isEditableProcedureDescription = true;
        let searchSelectionResultDTODossier = new SearchSelectionResultDTO();
        searchSelectionResultDTODossier.content = new Object();
        searchSelectionResultDTODossier.content.TIPO_EXPTE_ID = {};
        searchSelectionResultDTODossier.content.TIPO_EXPTE_ID.value = model.dto.procedureActionDossier.typeDossierId;
        searchSelectionResultDTODossier.content.TIPO_EXPTE_DESCRIP = {};
        searchSelectionResultDTODossier.content.TIPO_EXPTE_DESCRIP.value = model.dto.procedureActionDossier.typeDossierDescription;

        model.ui.procedureActionDossier_typeDossier_SearchGenericResult = searchSelectionResultDTODossier;

        if (model.dto.procedureActionDossier.actionDescription) {
          let searchSelectionResultDTOAction = new SearchSelectionResultDTO();
          searchSelectionResultDTOAction.content = new Object();
          searchSelectionResultDTOAction.content.ACTUACION_ID = {};
          searchSelectionResultDTOAction.content.ACTUACION_ID.value = model.dto.procedureActionDossier.actionId;
          searchSelectionResultDTOAction.content.ACTUACION_DESCRIP = {};
          searchSelectionResultDTOAction.content.ACTUACION_DESCRIP.value = model.dto.procedureActionDossier.actionDescription;

          model.ui.procedureActionDossier_typeAction_SearchGenericResult = searchSelectionResultDTOAction;
          model.ui.isEditableActionDescription = true;

          if (model.dto.procedureActionDossier.procedureDescription) {
            let searchSelectionResultDTOProcedure = new SearchSelectionResultDTO();
            searchSelectionResultDTOProcedure.content = new Object();
            searchSelectionResultDTOProcedure.content.TIPO_TRAMITACION_ID = {};
            searchSelectionResultDTOProcedure.content.TIPO_TRAMITACION_ID.value = model.dto.procedureActionDossier.procedureId;
            searchSelectionResultDTOProcedure.content.TIPO_TRAMITACION_DESCRIP = {};
            searchSelectionResultDTOProcedure.content.TIPO_TRAMITACION_DESCRIP.value = model.dto.procedureActionDossier.procedureDescription;

            model.ui.procedureActionDossier_typeProcedure_SearchGenericResult = searchSelectionResultDTOProcedure;
            model.ui.isEditableProcedureDescription = true;
          } else {
            this.setEditableProcedureDescription(model.dto.procedureActionDossier.typeDossierId, model.dto.procedureActionDossier.actionId);
          }
        }
      }
    }

    let modelObs: Observable<AccountingDocumentModel>;
    modelObs = of(model);
    return modelObs;
  }

  sortBudgetAccountLineInvoice(budgetAccountLineInvoice: BudgetAccountLineInvoiceAssociationDTO[]) {
    // GG_VIEW_CARGA_PARTIDA_FACT
    //ORDER BY APF.ID_PARTIDA, FACTURANUM, FACTURANUMSERIE;
    // Esta forma de ordenar coloca primero el numero antes que la letra
    // N-1; N-a -> En el applet: N-a; N-1
    // N-1; n-1  -> Este caso es igual en el applet


    // Explicación:
    //     '1'.charCodeAt(0) = 49
    //     '2'.charCodeAt(0) = 50
    //     'a'.charCodeAt(0) = 97
    //     'A'.charCodeAt(0) = 65

    return budgetAccountLineInvoice.sort((a, b) => {

      if (a.invoice.number > b.invoice.number) {
        return 1;
      } else if (a.invoice.number < b.invoice.number) {
        return -1;
      }
    });
  }


  sortBudgetAccountLineInvoiceold(budgetAccountLineInvoice: BudgetAccountLineInvoiceAssociationDTO[]) {
    // GG_VIEW_CARGA_PARTIDA_FACT
    //ORDER BY APF.ID_PARTIDA, FACTURANUM, FACTURANUMSERIE;
    // Esta forma de ordenar coloca primero el numero antes que la letra
    // N-1; N-a -> En el applet: N-a; N-1
    // N-1; n-1  -> Este caso es igual en el applet


    // Explicación:
    //     '1'.charCodeAt(0) = 49
    //     '2'.charCodeAt(0) = 50
    //     'a'.charCodeAt(0) = 97
    //     'A'.charCodeAt(0) = 65

    return budgetAccountLineInvoice.sort((a, b) => {
      if (a.budgetAccountLine.identifier > b.budgetAccountLine.identifier) {
        return 1;
      } else if (a.budgetAccountLine.identifier < b.budgetAccountLine.identifier) {
        return -1
      } else {
        if (a.invoice.number > b.invoice.number) {
          return 1;
        } else if (a.invoice.number < b.invoice.number) {
          return -1;
        } else {
          if (a.invoice.serialNumber > b.invoice.serialNumber) {
            return 1;
          }
        }
        return -1;
      }
    });
  }

  sortBudgetAccountLineInvoiceDiscount(budgetAccountLineInvoiceDiscount: BudgetAccountLineInvoiceDiscountAssociationDTO[]) {
    //GG_VIEW_CARGA_POSICION_DESC
    //ORDER BY D.DOCCONTABLENUMORDEN, ID_PARTIDA, FACTURANUM, FACTURANUMSERIE;
    // No hace falt ordenar por DOCCONTABLENUMORDEN

    // Esta forma de ordenar coloca primero el numero antes que la letra
    // N-1; N-a -> En el applet: N-a; N-1
    // N-1; n-1  -> Este caso es igual en el applet


    // Explicación:
    //     '1'.charCodeAt(0) = 49
    //     '2'.charCodeAt(0) = 50
    //     'a'.charCodeAt(0) = 97
    //     'A'.charCodeAt(0) = 65


    return budgetAccountLineInvoiceDiscount.sort((a, b) => {
      if (a.budgetAccountLine.identifier > b.budgetAccountLine.identifier) {
        return 1;
      } else if (a.budgetAccountLine.identifier < b.budgetAccountLine.identifier) {
        return -1
      } else {
        if (a.invoice.number > b.invoice.number) {
          return 1;
        } else if (a.invoice.number < b.invoice.number) {
          return -1;
        } else {
          if (a.invoice.serialNumber > b.invoice.serialNumber) {
            return 1;
          }
        }
        return -1;
      }
    });
  }


  normalizaDossierId(dossierId: string): string {
    return dossierId.substring(0, 4) + '/' + dossierId.substring(4);
  }

  modelToDTO(model: AccountingDocumentModel): AccountingDocumentDTO {

    // Antes de enviar a servidor
    model.dto = JSON.parse(
      JSON.stringify(model.dto, (k, v) => (k === '_parent' ? undefined : v))
    ); // Mirar!! Para evitar problemas en la serializacion*/

    if (lodash.isEmpty(model.dto.interested)) {
      model.dto.interested = null;
    }

    // assignee
    if (model.dto.assignee == undefined && (model.ui.companyAssignee && model.ui.companyAssignee.taxIdentifier
      && model.ui.companyAssignee.taxIdentifier != '')) {
      model.dto.assignee = new CompanyDocDTO();
      model.dto.assignee.type = 'C';
    }
    if (model.dto.assignee && (model.ui.companyAssignee == undefined || model.ui.companyAssignee.taxIdentifier == undefined
      || model.ui.companyAssignee.taxIdentifier == '')) {
      model.dto.assignee = null;
    } else if (model.dto.assignee && model.ui.companyAssignee) {
      model.dto.assignee.name = model.ui.companyAssignee.name;
      model.dto.assignee.taxIdentifier = model.ui.companyAssignee.taxIdentifier;
    }
    // beneficiary
    if (model.dto.beneficiary == undefined
      && (model.ui.companyBeneficiary && model.ui.companyBeneficiary.taxIdentifier && model.ui.companyBeneficiary.taxIdentifier != '')) {
      model.dto.beneficiary = new CompanyDocDTO();
      model.dto.beneficiary.type = 'P';
    }
    if (model.dto.beneficiary
      && (model.ui.companyBeneficiary == undefined
        || model.ui.companyBeneficiary.taxIdentifier == undefined
        || model.ui.companyBeneficiary.taxIdentifier == '')
      && ((model.dto.beneficiary.bankIdentifierCode == undefined || model.dto.beneficiary.bankIdentifierCode == '')
        && (model.dto.beneficiary.bankAccount == undefined || model.dto.beneficiary.bankAccount == ''))) {
      model.dto.beneficiary = null;
    } else if (model.dto.beneficiary && model.ui.companyBeneficiary) {
      model.dto.beneficiary.name = model.ui.companyBeneficiary.name;
      model.dto.beneficiary.taxIdentifier = model.ui.companyBeneficiary.taxIdentifier;
    }

    // console.log('************************************Personalización de cliente*****************************************');


    // *******************************************CIXTEC********************************************************************
    if (model.dto.beneficiary && model.dto.beneficiary.bankAccount) {
      model.dto.beneficiary.type = 'P';
    }
    if (model.dto.procedureActionDossier == undefined && model.ui.procedureActionDossier_typeDossier_SearchGenericResult) {
      model.dto.procedureActionDossier = new ProcedureActionDossierDTO();
    }
    if (model.dto.procedureActionDossier) {
      model.dto.procedureActionDossier.typeDossierId = null;
      model.dto.procedureActionDossier.actionId = null;
      model.dto.procedureActionDossier.procedureId = null;
      if (model.ui.procedureActionDossier_typeDossier_SearchGenericResult
        && model.ui.procedureActionDossier_typeDossier_SearchGenericResult.content
        && model.ui.procedureActionDossier_typeDossier_SearchGenericResult.content.TIPO_EXPTE_ID
        && model.ui.procedureActionDossier_typeDossier_SearchGenericResult.content.TIPO_EXPTE_ID.value) {

        model.dto.procedureActionDossier.typeDossierId =
          model.ui.procedureActionDossier_typeDossier_SearchGenericResult.content.TIPO_EXPTE_ID.value;

        if (model.ui.procedureActionDossier_typeAction_SearchGenericResult
          && model.ui.procedureActionDossier_typeAction_SearchGenericResult.content
          && model.ui.procedureActionDossier_typeAction_SearchGenericResult.content.ACTUACION_ID
          && model.ui.procedureActionDossier_typeAction_SearchGenericResult.content.ACTUACION_ID.value) {
          model.dto.procedureActionDossier.actionId =
            model.ui.procedureActionDossier_typeAction_SearchGenericResult.content.ACTUACION_ID.value;

          if (model.ui.procedureActionDossier_typeProcedure_SearchGenericResult
            && model.ui.procedureActionDossier_typeProcedure_SearchGenericResult.content
            && model.ui.procedureActionDossier_typeProcedure_SearchGenericResult.content.TIPO_TRAMITACION_ID
            && model.ui.procedureActionDossier_typeProcedure_SearchGenericResult.content.TIPO_TRAMITACION_ID.value) {
            model.dto.procedureActionDossier.procedureId =
              model.ui.procedureActionDossier_typeProcedure_SearchGenericResult.content.TIPO_TRAMITACION_ID.value;
          }
        }
      }
    }

    // *******************************************AYMAD********************************************************************

    let cliente = this.appConfig.getValue('cliente');
    // TODO 'AYMAD'
    //cliente = 'AYMAD';
    if ('AYMAD' === cliente) {
      if (model.dto.interested) {
        model.dto.interested = model.ui.integrationNITCompanyDocInterested;
      }

      // clean
      if (model.dto.budget.budgetAccountLine) {
        for (let budgetAccountLine of model.dto.budget.budgetAccountLine) {
          budgetAccountLine.budgetAccountLineInvoiceAssociates = null;
        }
      }
      if (model.ui.budgetAccountLineInvoiceAssociates) {
        for (let budgetAccountLineInvoiceAssociate of model.ui.budgetAccountLineInvoiceAssociates) {
          budgetAccountLineInvoiceAssociate.budgetAccountLineInvoiceDiscountAssociates = null;
        }
      }

      for (let budgetAccountLine of model.dto.budget.budgetAccountLine) {
        // Cargamos las facturas asociadas a las partidas
        // budgetAccountLine.budgetAccountLineInvoiceAssociates = null;
        if (model.ui.budgetAccountLineInvoiceAssociates) {
          if (budgetAccountLine.budgetAccountLineInvoiceAssociates == null) {
            budgetAccountLine.budgetAccountLineInvoiceAssociates = new Array<BudgetAccountLineInvoiceAssociationDTO>();
          }
          for (let budgetAccountLineInvoiceAssociate of model.ui.budgetAccountLineInvoiceAssociates) {
            //budgetAccountLineInvoiceAssociate.budgetAccountLineInvoiceDiscountAssociates = null;
            if (budgetAccountLine.identifier && budgetAccountLine.identifier === budgetAccountLineInvoiceAssociate.budgetAccountLine.identifier) {
              // Cargamos los descuentos asociados a la partida - detalle de la factura
              if (model.ui.budgetAccountLineInvoiceDiscountAssociates) {
                if (budgetAccountLineInvoiceAssociate.budgetAccountLineInvoiceDiscountAssociates == null) {
                  budgetAccountLineInvoiceAssociate.budgetAccountLineInvoiceDiscountAssociates = new Array<BudgetAccountLineInvoiceDiscountAssociationDTO>();
                }
                let budgetAccountLineInvoiceDiscounts = new Array<BudgetAccountLineInvoiceDiscountAssociationDTO>();

                for (let budgetAccountLineInvoiceDiscount of model.ui.budgetAccountLineInvoiceDiscountAssociates) {
                  if (budgetAccountLine.identifier === budgetAccountLineInvoiceDiscount.budgetAccountLine.identifier
                    && budgetAccountLineInvoiceAssociate.invoiceDetailLine.identifier === budgetAccountLineInvoiceDiscount.invoiceDetailLine.identifier) {
                    budgetAccountLineInvoiceDiscounts.push(budgetAccountLineInvoiceDiscount);
                  }
                }
                budgetAccountLineInvoiceAssociate.budgetAccountLineInvoiceDiscountAssociates.push(...budgetAccountLineInvoiceDiscounts);
              }
              budgetAccountLine.budgetAccountLineInvoiceAssociates.push(budgetAccountLineInvoiceAssociate);
            }
          }
          //**********************************************************************************************************************************************/
          //******* La asociación entre documento contable y factura (ASASOCIA_DOCCONTABLE_FACTURA -> trigger -> ASOCIADOCS) se hace en servidor!! **/
          //**********************************************************************************************************************************************/
        }
      }
      model.dto.budget.budgetAccountLine = JSON.parse(
        JSON.stringify(model.dto.budget.budgetAccountLine, (k, v) => (k === '_parent' ? undefined : v))
      );
    }

    //console.log('************************************FIN Personalización de cliente AYMAD*****************************************');
    //*****************************************************************************************************************************





    // ojo!!
    // Tarea corregir. Pasa dos veces por este metodo, la segunda vez  lo invoca getTask(): TaskDTO
    // y aqui es donde se hace model.ui = {}, por este motivo al hacer el concat de dos objetos undefined se crea
    // un array con dos elementos vacios.
    // SE modifica el metodo getTask() para que no model.ui = {}, por este motivo se comenta al fina el siguiente if
    // if (model.ui.notVisibleRelatedDocuments && model.ui.visibleRelatedDocuments) {
    model.dto.document.relatedDocuments = [].concat(model.ui.notVisibleRelatedDocuments, model.ui.visibleRelatedDocuments);
    // Mirar!! Para evitar problemas en la serializacion*/
    model.dto.document.relatedDocuments = JSON.parse(
      JSON.stringify(model.dto.document.relatedDocuments, (k, v) => (k === '_parent' ? undefined : v))
    );
    // }


    if (this.task && this.task.work && this.task.work.expenseDocument) {
      // this.task.work.expenseDocument = model.dto;
    } else {
      model.dto.task = this.task;
    }

    return model.dto;
  }

  getTitle(): string {
    if (this.model && this.model.dto) {
      if (this.task && this.task.work) {
        let actionTask = this.task?.work?.context?.configurations['accionTask'];
        if (actionTask) {
          if (this.task.work.expenseDocument && actionTask.value == '__VALIDA') {
            return this.translateService.instant('ExpenseDocument.title.pantalla.validate')
              + this.model.dto.expenseDocumentType.description;
          } else if (actionTask.value == '__DATOS_ASOC') {
            return this.translateService.instant('ExpenseDocument.title.pantalla.associateElectronicDocuments')
              + this.model.dto.expenseDocumentType.description;
          } else if (actionTask.value == '__DATOS_CONTAB') {
            return this.translateService.instant('ExpenseDocument.title.pantalla.posting') + this.model.dto.expenseDocumentType.description;
          }
        }
      }
      return this.translateService.instant('ExpenseDocument.title.pantalla.edit') + this.model.dto.expenseDocumentType.description;
    } else {
      return this.translateService.instant('ExpenseDocument.title.pantalla.new') + this.model.dto.expenseDocumentType.description;
    }
  }

  getHeaderInfo(): BaseFormHeaderInfo {
    let headerInfo = new BaseFormHeaderInfo();
    headerInfo.titleKey = this.getTitle();
    headerInfo.titleIcon = 'fas fas fa-file-invoice-dollar';
    if (this.model && this.model.dto && this.model.dto.division && this.model.dto.division.project) {
      headerInfo.project = this.model.dto.division.project;
    }
    return headerInfo;
  }
  setBotoneraAYMAD() {
    // Siempre va a ser modal!!
    this.subscribe(
      this.headerActionsService.addWindowAction(
        'Ver errores',
        '',
        'btn-primary',
        () => this.isAvailableAction('EXPENSEDOCUMENT_INTEGRATION_SHOW_ERRORS'),
        this.windowHash
      ),
      () => { // next addWindowAction
        console.log('******************************************** next addWindowAction');
        this.subscribe(
          this.showErrors(),
          (actionResult: ActionResultDTO) => { // next Ver errores
            console.log('******************************************** next Ver errores');
            this.waitService.cancelWaiting();
            if (actionResult) {
              if ('OK' === actionResult.identifier) {
                // if (actionResult.objectResult) {
                if (actionResult.description) {
                  this.uiService.showMessage(actionResult.description, 'Errores en la comunicación con SAP', 'errorStyle');
                }
                // this.ref.close();
              } else {
                let message = this.translate.instant('General.errorMessage');
                if (actionResult.description) {
                  message = actionResult.description;
                }
                this.uiService.showMessage(message, 'Error al consultar los errores en la comunicación con SAP', 'errorStyle');
              }
            }
          },
          (error: any) => { // error  Ver errores
            console.log('******************************************** error Ver errores');
            this.waitService.cancelWaiting();
            this.manageActionError(error, true);
          }
        );
      }
    );
    if (!this.showDocument) {
      let isAvailablePOSTRETURNAction = true
      if (this.task.work.context.configurations['isPostedTask'].value
        && this.expenseManagementLine.expenseTaskStatus === ExpenseTaskStates.COMPLETED
        && this.expenseManagementLine.isExpenseDocument
        && this.expenseManagementLine.expenseDocument) {
        isAvailablePOSTRETURNAction = false;
      }


      if (isAvailablePOSTRETURNAction) {
        this.subscribe(
          this.headerActionsService.addWindowAction(
            'Devolver',
            '',
            'btn-primary show-text-onxs ',
            () => this.isAvailableAction('EXPENSEDOCUMENT_RETURN'),
            this.windowHash
          ),
          () => { // next addWindowAction
            console.log('******************************************** next addWindowAction');
            this.subscribe(
              this.devolver().pipe(
                tap((actionResult: ActionResultDTO) => { // next devolución
                  console.log('******************************************** next devolver');
                  this.waitService.cancelWaiting();
                  if (actionResult) {
                    if ('OK' === actionResult.identifier) {
                      if (actionResult.objectResult) {
                        // result.objectResult;
                      }
                      this.ref.close(this.model);
                    } else {
                      let message = this.translate.instant('General.errorMessage');
                      if (actionResult.description) {
                        message = actionResult.description;
                      }
                      this.uiService.showMessage(message, 'Sincronización con SAP la devolución.', 'errorStyle');
                    }
                  }
                }
                ),
                catchError(
                  (err) => {
                    console.log('******************************************** error devolución');
                    this.plycaErrorHandler.showServerError(err);
                    this.waitService.cancelWaiting();
                    //this.ref.close();
                    return of(true);
                  }
                ),
                finalize(() => { })
              )
            );
          }
        );
      }

      if (isAvailablePOSTRETURNAction) {
        this.subscribe(
          this.headerActionsService.addWindowAction(
            'Contabilizar',
            '',
            'btn-primary show-text-onxs ',
            () => this.isAvailableAction('EXPENSEDOCUMENT_POST'),
            this.windowHash
          ),
          () => { // next addWindowAction
            console.log('******************************************** next addWindowAction');
            this.subscribe(
              this.contabilizar().pipe(
                tap((actionResult: ActionResultDTO) => { // next contabilizar
                  console.log('******************************************** next contabilización');
                  this.waitService.cancelWaiting();
                  if (actionResult) {
                    if ('OK' === actionResult.identifier) {
                      if (actionResult.objectResult) {
                        // result.objectResult;
                      }
                      this.ref.close(this.model);
                    } else {
                      let message = this.translate.instant('General.errorMessage');
                      if (actionResult.description) {
                        message = actionResult.description;
                      }
                      this.uiService.showMessage(message, 'Sincronización con SAP la contabilización.', 'errorStyle');
                    }
                  }
                }),
                catchError(
                  (err) => {
                    console.log('******************************************** error contabilización');
                    this.plycaErrorHandler.showServerError(err);
                    this.waitService.cancelWaiting();
                    //this.ref.close();
                    return of(true);
                  }),
                finalize(() => { })
              )
            );
          }
        );
      }

      this.subscribe(
        this.headerActionsService.addWindowAction(
          'Aceptar',
          '',
          'btn-primary',
          () => this.isAvailableAction('EXPENSEDOCUMENT_MANUAL_STATE_CHANGE'),
          this.windowHash
        ),
        () => { // next addWindowAction
          console.log('******************************************** next addWindowAction');
          this.subscribe(
            this.manualStateChange(),
            (ret: any) => { // next validar
              console.log('******************************************** next validar');
              this.waitService.cancelWaiting();
              this.ref.close(this.model);
              /*if (actionResult) {
                if ('OK' === actionResult.identifier) {
                  if (actionResult.objectResult) {
                    // result.objectResult;
                  }
                  this.ref.close();
                } else {
                  let message = this.translate.instant('General.errorMessage');
                  if (actionResult.description) {
                    message = actionResult.description;
                  }
                  this.uiService.showMessage(message, 'Sincronización con SAP la validación.', 'errorStyle');
                }
              }*/
            },
            (error: any) => { // error validar
              console.log('******************************************** error validar');
              this.waitService.cancelWaiting();
              this.manageActionError(error, true);
            }
          );
        }
      );
      if (!this.task.work.context.configurations['isPostedTask'].value) {
        this.headerActionsService.addWindowDivider(this.windowHash);
        this.addSaveButton();
      }
    }
  }

  initHeaderActions() {
    console.log('******************************************** initHeaderActions');
    // No queremos mostrar la botonera si estmaos abriendo la pantalla desde ver formulario.
    let cliente = this.appConfig.getValue('cliente');
    // TODO 'AYMAD'
    //cliente = 'AYMAD';
    if ('AYMAD' === cliente) {
      this.setBotoneraAYMAD();
    } else {
      // Cuando estemos abriendo la pantalla desde ver formulario no informamos la tarea
      if (this.task && this.task.work && this.task.work.expenseDocument) {
        // ********************************************************************************************************************************
        // *** Si this.task.work.expenseDocument existe quiere decir que es una tarea de documento contable y no de gestión del gasto!! ***
        // ********************************************************************************************************************************
        let actionTask = this.task.work.context.configurations['accionTask'];
        if (actionTask && actionTask.value === '__VALIDA') {
          this.subscribe(this.headerActionsService
            .addAction(
              'General.validate',
              '',
              'btn-primary',
              true
            ), () => {
              this.subscribe(this.saveIfValid());
            });
        } else {
          this.subscribe(this.headerActionsService
            .addAction(
              'General.save',
              //'saveIfValid - processTaskObservable',
              'fas fa-save',
              'btn-primary',
              true
            ), () => {
              this.subscribe(this.saveIfValid());
            });
        }
        this.headerActionsService.addDivider();
        this.addBackAction();
      } else if (!this.showDocument) {// Solo se mostrará si no estamosa abriendo la pantalla desde ver formulario
        // ********************************************************************************************************************************
        // ******************************************** Siempre va a ser modal ************************************************************
        // ********************************************************************************************************************************
        if (this.identifier && 'CIXTEC' === cliente) {
          // Evaluamos si el botón de ver errores de integración debe estar visible
          this.subscribe(this.plycaService
            .getAttributeValue(
              'ERRORES_INTEGRACION_SISTEMA_CONTABLE',
              /*'PROPUESTAID=' + '2018/0002000013'
              + '&LOTEID=' + '1'
              + '&LISTADOCID=' + '00010'
              + '&DOCCONTABLENUMORDEN=' + '3'*/
              'PROPUESTAID=' + this.model.ui.dossierId.substring(0, 4) + '/' + this.model.ui.dossierId.substring(4)
              + '&LOTEID=' + this.model.ui.docDivisionId
              + '&LISTADOCID=' + this.model.dto.documentClass.identifier
              + '&DOCCONTABLENUMORDEN=' + this.model.dto.orderNumber
            )
            .pipe(finalize(() => {
              this.addSaveButton();
            })),
            x => {
              if (x.values && x.values.length > 0) {
                this.subscribe(this.headerActionsService.addWindowAction(
                  'Ver errores',
                  'fas fa-sync-alt',
                  'btn-secondary',
                  true,
                  this.windowHash
                ), () => {
                  this.openAtributeDialog();
                });
              }
            },
            err => {
              this.uiService.showMessage(
                'Error cargando datos atributo: ERRORES_INTEGRACION_SISTEMA_CONTABLE',
                this.translateService.instant('General.error'),
                'errorStyle'
              );
              console.log('Error cargando datos atributo: ERRORES_INTEGRACION_SISTEMA_CONTABLE');
              console.log(err);
            }
          );
        } else {
          this.addSaveButton();
        }
      }
    }

    this.botoneraLoaded = true;
  }


  public getAvailableActions(): Observable<any> {
    console.log('******************************************** getAvailableActions');
    if (this.identifier && !this.loadedLazyActions && this.isDisabled != 'disabled') {
      this.isDisabled = 'disabled';
      let lista = [].concat(this.visibleAndAvailableActions);
      let taskId: any;
      if (this.task) {
        taskId = this.task.identifier;
      }

      const taskExpansion = new Array<string>();
      taskExpansion.push('WITHOUT_WORK_WITHOUT_ACTIONS');
      let availableActions = this.plycaService.getAvailableActions('EXPENSEDOCUMENT', this.identifier, taskId, taskExpansion)
        .pipe(
          tap(
            (actions: LinkedActionsDTO) => {
              console.log('******************************************** next getAvailableActions');
              this.availableLinkedActions = actions;
              if (actions && actions.actions) {

                this.availableActions = actions.actions;
                actions.actions.forEach(
                  action => {
                    this.processAction(action, lista);
                  }
                )

              }
              this.loadedLazyActions = true;
              this.isDisabled = '';
              this.visibleAndAvailableActions = lista;
            }
          ),
          catchError((error: any) => {
            this.plycaErrorHandler.showServerError(error);
            return throwError(error);
          }),
          finalize(
            () => {
            })
        );
      return availableActions;
    } else {
      return of({});
    }
  }


  protected processAction(action: ActionDTO, lista: ActionDTO[]) {
    // ******************************************No filtramos las visibles!! **************************************************

    // if (action.visible) {
    // lista.push(action)
    // } else {
    //  console.log('La acción ' + action.identifier + ' se ignora por la configuración de visibilidad del cliente');
    // }
    lista.push(action)
  }

  private contabilizar(): Observable<ActionResultDTO> {
    this.waitService.startWaiting('Sincronizando con SAP...');
    let filteredActionsContabilizar: Array<ActionDTO>;
    filteredActionsContabilizar = this.visibleAndAvailableActions.filter(
      action => action && action.identifier === 'EXPENSEDOCUMENT_POST'
    );

    let actionPost: ActionDTO;
    actionPost = filteredActionsContabilizar[0];

    if (actionPost) {
      return this.excuteExpenseDocumentAction(actionPost);
    } else {
      return this.uiService.showMessage(
        'No esta disponible la acción para este documento contable',
        this.translateService.instant('General.error'),
        'errorStyle'
      ).onClose;
    }
  }
  private showErrors(): Observable<ActionResultDTO> {
    this.waitService.startWaiting('Recuperando los errores de comunncación con SAP...');
    let filteredActionsShowErrors: Array<ActionDTO>;
    filteredActionsShowErrors = this.visibleAndAvailableActions.filter(
      action => action && action.identifier === 'EXPENSEDOCUMENT_INTEGRATION_SHOW_ERRORS'
    );

    let actionShowErrors: ActionDTO;
    actionShowErrors = filteredActionsShowErrors[0];

    if (actionShowErrors) {
      return this.excuteExpenseDocumentAction(actionShowErrors);
    } else {
      return this.uiService.showMessage(
        'No esta disponible la acción para este documento contable',
        this.translateService.instant('General.error'),
        'errorStyle'
      ).onClose;
    }
  }


  private devolver(): Observable<ActionResultDTO> {
    this.waitService.startWaiting('Sincronizando con SAP. Devolución...');
    let filteredActionsReturn: Array<ActionDTO>;
    filteredActionsReturn = this.visibleAndAvailableActions.filter(
      action => action && action.identifier === 'EXPENSEDOCUMENT_RETURN'
    );

    let actionReturn: ActionDTO;
    actionReturn = filteredActionsReturn[0];

    if (actionReturn) {
      return this.excuteExpenseDocumentAction(actionReturn);
    } else {
      return this.uiService.showMessage(
        'No esta disponible la acción para este documento contable',
        this.translateService.instant('General.error'),
        'errorStyle'
      ).onClose;
    }
  }


  private manualStateChange(): Observable<any> {
    this.waitService.startWaiting('Validación...');
    let filteredActionsValidate: Array<ActionDTO>;
    filteredActionsValidate = this.visibleAndAvailableActions.filter(
      action => action && action.identifier === 'EXPENSEDOCUMENT_MANUAL_STATE_CHANGE'
    );

    let actionValidate: ActionDTO;
    actionValidate = filteredActionsValidate[0];
    if (actionValidate) {
      if (actionValidate.needsPreparation) {
        return this.prepareAction(actionValidate);
      }
      // return this.excuteExpenseDocumentAction(actionValidate);
    } else {
      return this.uiService.showMessage(
        'No esta disponible la acción para este documento contable',
        this.translateService.instant('General.error'),
        'errorStyle'
      ).onClose;
    }
    return EMPTY; // LLeva al finally
  }

  private prepareAction(action: ActionDTO): Observable<any> {
    // let paramTarget = this.getParameter('TARGET');
    let params: any = {};
    // if (paramTarget) {
    //  params.TARGET = paramTarget.value;
    // } else {
    params.TARGET = action.target ? action.target.identifier : null;
    // }

    if (this.task) {
      params.taskId = this.task.identifier;
    }

    if (params.TARGET) {
      let url = '/userAPI/v1/actions/' + action['definition'].identifier;
      return this.plycaService
        .get(url, '/preparation', params)
        .pipe(
          switchMap(
            (act: any) => {
              if (act) { // POSSIBLE_STATES, ACTUAL_STATE
                action = act;
                // this.openModal(null, action);
                return this.openModalAction(action).onClose;
              } else {
                return of({});
              }
            }
          ),
          finalize(() => {
            this.waitService.cancelWaiting();
          })
        )
    }
  }

  openModalAction(action: any, component = ActionsProcessComponent): DynamicDialogRef {
    // let actionParameters: Array<ActionParameterDTO> = new Array<ActionParameterDTO>();
    // actionParameters = action.parameters;
    if (action.parameters) {
      action.parameters.forEach(
        (parameter: ActionParameterDTO) => { // ActionParameterDTO
          if (parameter.name === 'taskId') {
            parameter.visible = false; // No queremos que se muestre el campo.
            if (this.task) {
              parameter.value = this.task.identifier; // Informamos el parametro con su valor cargado.
            }
          }
        });
    }

    let headerTitle = action.name + ': ' + (this.model.dto.description ? this.model.dto.description : '');
    headerTitle = headerTitle.substr(0, 100) + '...';
    let config: DynamicDialogConfig = {
      header: headerTitle,

      width: '70%',
      styleClass: 'actionStyle',
      style: { overflow: 'hidden' }
    };
    config['action'] = action;
    // config['paramsDef'] = action.definition.parametersDefinition;
    config['dto'] = this.model.dto;

    return this.dialogService.open(component, config);
  }

  private isAvailableAction(actionName: String): Boolean {
    let filteredActionsContabilizar: Array<ActionDTO>;
    if (this.visibleAndAvailableActions) {
      filteredActionsContabilizar = this.visibleAndAvailableActions.filter(
        action => action && action.identifier === actionName
      );
      return (filteredActionsContabilizar && filteredActionsContabilizar.length === 1);
    } else {
      return false;
    }
  }

  private excuteExpenseDocumentAction(action: ActionDTO): Observable<ActionResultDTO> {
    let objectType = 'EXPENSEDOCUMENT';
    let parameters: any;
    let actionReturnObs: Observable<ActionResultDTO>

    if (this.task) {
      parameters = 'taskId=' + this.task.identifier;
    }
    actionReturnObs = this.plycaService.runActionLink(action, parameters);
    console.log('******************************************** return obserble resultado del  runActionLink');
    return actionReturnObs;

    //return EMPTY; // LLeva al finally
  }

  configureFormConfig(formConfig: FormConfig): Observable<FormConfig> {

    let obs = this.getAvailableActions();

    return obs.pipe(
      switchMap(
        (actions: LinkedActionsDTO) => {
          /*if (act) { // POSSIBLE_STATES, ACTUAL_STATE
            action = act;
            // this.openModal(null, action);
            return this.openModalAction(action).onClose;
          } else {
            return of({});
          }*/

          let obsFormConfig: Observable<FormConfig> = this.configureFormConfig2(formConfig);
          return obsFormConfig;
        }
      ),
      catchError((error: any) => {
        this.manageActionError(error);
        return throwError(error);
      }),
      finalize(() => {
        this.waitService.cancelWaiting();
      }))
    //,(error: any) => this.waitService.cancelWaiting()

  }

  configureFormConfig2(formConfig: FormConfig): Observable<FormConfig> {
    formConfig.showValidations = true;

    if (this.isModal) {
      formConfig.isModalWindow = true;
      this.windowHash = generateRandomIdentifier();
      formConfig.windowHash = this.windowHash;
    }
    let helpTags = [HelpType.EXPENSE_DOCUMENT];
    let actionValidateMANUAL_STATE_CHANGE: ActionDTO;
    let actionValidateEXPENSEDOCUMENT_POST: ActionDTO;
    let actionValidateEXPENSEDOCUMENT_RETURN: ActionDTO;

    if (this.visibleAndAvailableActions !== undefined) {
      let filteredActionsValidate: Array<ActionDTO>;
      filteredActionsValidate = this.visibleAndAvailableActions.filter(
        action => action && action.identifier === 'EXPENSEDOCUMENT_MANUAL_STATE_CHANGE'
      );
      actionValidateMANUAL_STATE_CHANGE = filteredActionsValidate[0];

      filteredActionsValidate = this.visibleAndAvailableActions.filter(
        action => action && action.identifier === 'EXPENSEDOCUMENT_POST'
      );
      actionValidateEXPENSEDOCUMENT_POST = filteredActionsValidate[0];

      filteredActionsValidate = this.visibleAndAvailableActions.filter(
        action => action && action.identifier === 'EXPENSEDOCUMENT_RETURN'
      );
      actionValidateEXPENSEDOCUMENT_RETURN = filteredActionsValidate[0];

    }
    let cliente = this.appConfig.getValue('cliente');
    // TODO 'AYMAD'
    // cliente = 'AYMAD';

    if (this.showDocument) {
      helpTags = helpTags.concat(HelpType.VIEW_EXPENSE_DOCUMENT);
    } else if (this.model?.dto?.identifier === undefined) {
      helpTags = helpTags.concat(HelpType.NEW_EXPENSE_DOCUMENT);
    } else if ('AYMAD' === cliente) {
      if (actionValidateMANUAL_STATE_CHANGE) {
        helpTags = helpTags.concat(HelpType.VALIDATE_EXPENSE_DOCUMENT);
      } else if (actionValidateEXPENSEDOCUMENT_RETURN || actionValidateEXPENSEDOCUMENT_POST) {
        helpTags = helpTags.concat(HelpType.POST_EXPENSE_DOCUMENT);
      } else {
        helpTags = helpTags.concat(HelpType.EDIT_EXPENSE_DOCUMENT);
      }
    } else if (this.task?.work?.context?.configurations['accionTask']?.value) {
      if (this.task.work.context.configurations['accionTask']?.value === '__VALIDA') {
        helpTags = helpTags.concat(HelpType.VALIDATE_EXPENSE_DOCUMENT);
      } else if (this.task.work.context.configurations['accionTask']?.value === '__DATOS'
        || this.task.work.context.configurations['accionTask']?.value === '__REPARA' ||
        this.task.work.context.configurations['accionTask']?.value === '__DATOS_CONTAB') {
        helpTags = helpTags.concat(HelpType.EDIT_EXPENSE_DOCUMENT);
      }
    }

    formConfig.searchTags = helpTags;

    formConfig.functions.push({
      identifier: 'addInvoice',
      fn: this.addInvoice.bind(this)
    });
    formConfig.functions.push({
      identifier: 'removeBudgetAccountLine',
      fn: this.removeBudgetAccountLine.bind(this)
    });
    formConfig.functions.push({
      identifier: 'onChangeRowRemoveBudgetAccountLine',
      fn: this.onChangeRowRemoveBudgetAccountLine.bind(this)
    });
    formConfig.functions.push({
      identifier: 'removeBudgetAccountLineInvoice',
      fn: this.removeBudgetAccountLineInvoice.bind(this)
    });
    formConfig.functions.push({
      identifier: 'removeBudgetAccountLineInvoiceDiscount',
      fn: this.removeBudgetAccountLineInvoiceDiscount.bind(this)
    });
    formConfig.functions.push({
      identifier: 'removeBudgetAccountLineInvoiceAssociation',
      fn: this.removeBudgetAccountLineInvoiceAssociation.bind(this)
    });
    formConfig.functions.push({
      identifier: 'addBudgetAccountLine',
      fn: this.addBudgetAccountLine.bind(this)
    });
    formConfig.functions.push({
      identifier: 'addBudgetAccountLineInvoice',
      fn: this.addBudgetAccountLineInvoice.bind(this)
    });
    formConfig.functions.push({
      identifier: 'addBudgetAccountLineInvoiceDiscount',
      fn: this.addBudgetAccountLineInvoiceDiscount.bind(this)
    });
    formConfig.functions.push({
      identifier: 'addRelatedDocument',
      fn: this.addRelatedDocument
    });
    formConfig.functions.push({
      identifier: 'changeDossierDescription',
      fn: this.changeDossierDescription.bind(this)
    });
    formConfig.functions.push({
      identifier: 'changeActionDescription',
      fn: this.changeActionDescription.bind(this)
    });
    /*
    formConfig.functions.push({
      identifier: 'onChangePartidasServicioSearch',
      fn: this.onChangePartidasServicioSearch.bind(this)
    });*/
    formConfig.functions.push({
      identifier: 'openPartidasServicioSearch',
      fn: this.openPartidasServicioSearch
    });
    formConfig.functions.push({
      identifier: 'openOrganicaSearch',
      fn: this.openOrganicaSearch
    });
    formConfig.functions.push({
      identifier: 'onChangeAmountWithTaxesBudgetAccountLine',
      fn: this.onChangeAmountWithTaxesBudgetAccountLine.bind(this)
    });
    formConfig.functions.push({
      identifier: 'onChangeAmountInvoice',
      fn: this.onChangeAmountInvoice.bind(this)
    });
    formConfig.functions.push({
      identifier: 'onChangeAmountDiscount',
      fn: this.onChangeAmountDiscount.bind(this)
    });
    formConfig.functions.push({
      identifier: 'openBankTypeSearch',
      fn: this.openBankTypeSearch
    });
    formConfig.functions.push({
      identifier: 'openMovementType',
      fn: this.openMovementType
    });
    formConfig.functions.push({
      identifier: 'openActivoFijoSearch',
      fn: this.openActivoFijoSearch
    });


    formConfig.functions.push({
      identifier: 'onChangeIntegrationBankType',
      fn: this.onChangeIntegrationBankType.bind(this)
    });
    formConfig.functions.push({
      identifier: 'onChangeIntegrationInterestedNIT',
      fn: this.onChangeIntegrationInterestedNIT.bind(this)
    });
    formConfig.functions.push({
      identifier: 'onChangeInterestedDNICIF',
      fn: this.onChangeInterestedDNICIF.bind(this)
    });
    formConfig.functions.push({
      identifier: 'isBarrado',
      fn: this.isBarrado.bind(this)
    });
    formConfig.functions.push({
      identifier: 'editMode',
      fn: this.editMode
    });
    formConfig.functions.push({
      identifier: 'editModeWithSign',
      fn: this.editModeWithSign
    });
    formConfig.functions.push({
      identifier: 'editModeTableWithSign',
      fn: this.editModeTableWithSign
    });
    formConfig.functions.push({
      identifier: 'editBudgetAccountLineTable',
      fn: this.editBudgetAccountLineTable
    });
    formConfig.functions.push({
      identifier: 'startsWith6Economical',
      fn: this.startsWith6Economical
    });
    formConfig.functions.push({
      identifier: 'defaultValueEligibility',
      fn: this.defaultValueEligibility
    });
    formConfig.functions.push({
      identifier: 'editModeTable',
      fn: this.editModeTable
    });

    formConfig.functions.push({
      identifier: 'showInvoicePdf',
      fn: this.showInvoicePdf.bind(this) // Para tener acceso al documentService
    });

    formConfig.functions.push({
      identifier: 'showAttachFiles',
      fn: this.showAttachFiles.bind(this)  // Para tener acceso al documentService
    });

    this.readonlyModeInputActions = false;
    if ((this.task?.work?.context?.configurations['accionTask'].value === '__VALIDA')
      || this.task?.work?.context?.configurations['isPostedTask'].value) {
      formConfig.readonly = true;
      this.model.ui.readonlyModeInputActions = formConfig.readonly;
    }
    if (this.showDocument === true) {
      formConfig.readonly = true;
      this.model.ui.readonlyModeInputActions = formConfig.readonly;
    }


    return of(formConfig);
  }
  public isBarrado(model: any) { //model = formElementComponent  -> _parent = AccountingDocumentModel

    let isBarrado = false;
    if (model?.dto) {
      isBarrado = (model.dto.sign === 1);
    } else if (model?._parent?.dto) {
      isBarrado = (model._parent.dto.sign === 1);
    } else {
      console.log('***********************************************************************************************************************************');
      console.log('***********************************************************************************************************************************');
      console.log('********************************************** isBarrado? *************************************************************************');
      console.log('***********************************************************************************************************************************');
      console.log('***********************************************************************************************************************************');
    }
    return isBarrado;
  }

  public editMode(model: any) {// model = AccountingDocumentModel
    // No funciona en las tablas!!

    // this.isEditModeTable(model, false); Falla!! porque this no es AccountingDocumentComponent es un AccountingDocumentModel
    // por esta razón hacemos static el metodo isEditModeTable
    let isEdit = AccountingDocumentComponent.isEditMode(model, false);
    return isEdit;
  }

  public editModeWithSign(model: any) {// model = AccountingDocumentModel
    // No funciona en las tablas!!

    // this.isEditModeTable(model, true); Falla!! porque this no es AccountingDocumentComponent es un AccountingDocumentModel
    // por esta razón hacemos static el metodo isEditModeTable
    let isEdit = AccountingDocumentComponent.isEditMode(model, true);
    return isEdit;
  }




  public editModeTable(model: any) { // model = formElementComponent  -> _parent = AccountingDocumentModel
    // this.isEditModeTable(model, false); Falla!! porque this no es AccountingDocumentComponent es un FormElementComponent
    // por esta razón hacemos static el metodo isEditModeTable
    let isEdit = AccountingDocumentComponent.isEditModeTable(model, false);
    return isEdit;
  }

  public editModeTableWithSign(withSign: boolean, model: any): boolean {
    // this.isEditModeTable(model, true); Falla!! porque this no es AccountingDocumentComponent es un FormElementComponent
    // por esta razón hacemos static el metodo isEditModeTable
    let isEdit = AccountingDocumentComponent.isEditModeTable(model, true);
    return isEdit;
  }

  public editBudgetAccountLineTable(model: any): boolean {
    let isEdit = false;
    // Si la funcion esta definida declarada en la etiqueta "editable" del json
    if (model._parent && model._parent.dto) {
      isEdit = model._parent.dto.context.configurations.isEditableColumnsBudgetAccountLine.value == true;
    } else if (model.dto && model.dto.context) { // Si la funcion esta definida declarada en la etiqueta  "colVisibility" del json
      isEdit = model.dto.context.configurations.isEditableColumnsBudgetAccountLine.value == true;
    } else {
      console.log('******************************************editBudgetAccountLineTable: Error sin controlar *****************************************');
    }

    return isEdit;
  }
  public startsWith6Economical(model: any): boolean {
    let startsWith6 = false;
    if (model.economical) {
      let economical: string = model.economical;
      startsWith6 = economical.startsWith('6');
    }
    return startsWith6;
  }



  modalError(error) {
    this.ref.close();
    this.plycaErrorHandler.showServerError(error);
    // this.uiService.showMessage(
    //   error.errors[0].message,
    //   this.translateService.instant('General.error'),
    //   'errorStyle'
    // );
  }


  private initDraftFiles(dto): void {

    let tmpDrafFiles: Array<FileDetailsDTO> = [];
    let temporalFiles: Array<FileDetailsDTO> = [];
    if (
      dto != null && dto.document != null &&
      dto.document.currentVersion != null &&
      dto.document.currentVersion.files != null
    ) {
      let allFiles: Array<FileDetailsDTO> = [];
      tmpDrafFiles = this.documentService.getTypeDocument(
        DocumentFileTypeDTO.Draft,
        dto.document
      );
      temporalFiles = this.documentService.getTypeDocument(
        DocumentFileTypeDTO.Temporal,
        dto.document
      );
      allFiles = tmpDrafFiles.concat(temporalFiles);

      dto.document.currentVersion.files = allFiles;
    } else {
      if (dto.document.currentVersion == null) {
        dto.document.currentVersion = new DocumentVersionDTO();
      }
      dto.document.currentVersion.files = tmpDrafFiles;
    }
  }
  addRelatedDocument() {
    let parametersURL: ActionParameterDefinitionDTO[] = [];

    let param1 = new ActionParameterDefinitionDTO();
    param1.identifier = 'DOCSDIRECTORIO.PROPUESTAID';
    param1.value = this.model.ui.dossierId.substring(0, 4) + '/' + this.model.ui.dossierId.substring(4);

    parametersURL.push(param1);
    // let param2 = new ActionParameterDefinitionDTO();
    // param2.identifier = "FACTURAS.FAC_LOTEID";
    // param2.value = this.model.ui.docDivisionId;
    // if (this.model.ui.award && this.model.ui.award.division) {
    //  let divisionIdAward = getSimpleIdentifierFromString(this.model.ui.award.division.identifier);
    //  if (divisionIdAward != param2.value) {
    //    param2.value = divisionIdAward + "," + param2.value;
    //  }
    // }
    // parametersURL.push(param2);

    // let relatedDocuments = this.model.dto.document.relatedDocuments;
    let relatedDocuments = this.model.ui.visibleRelatedDocuments;
    let excludedDocuments = '';
    if (relatedDocuments) {
      for (let i in relatedDocuments) {
        if (relatedDocuments[i]) {
          if (excludedDocuments && excludedDocuments !== '') {
            excludedDocuments = excludedDocuments + '\',\'';
          }
          excludedDocuments = excludedDocuments + relatedDocuments[i].document.identifier;
        }
      }
    }

    if (this.model.ui.notVisibleRelatedDocuments) {
      for (let i in this.model.ui.notVisibleRelatedDocuments) {
        if (this.model.ui.notVisibleRelatedDocuments[i]) {
          if (excludedDocuments && excludedDocuments !== '') {
            excludedDocuments = excludedDocuments + '\',\'';
          }
          excludedDocuments = excludedDocuments + this.model.ui.notVisibleRelatedDocuments[i].document.identifier;
        }
      }
    }


    if (excludedDocuments && excludedDocuments !== '') {
      let param3 = new ActionParameterDefinitionDTO();
      param3.identifier = 'RELATEDDOCUMENTS_ASSOCIATES.UUID';
      param3.value = excludedDocuments;
      parametersURL.push(param3);
    }

    let contextSearch = new SearchSettingDTOModal(
      'RELATEDDOCUMENTS',
      false,
      parametersURL
    );

    let config: DynamicDialogConfig = {
      header: '',
      width: '70%',
      style: { overflow: 'scroll', 'max-height': '80%' }
    };
    config['context'] = contextSearch;
    let ref = this.dialogService.open(searchGenericComponent, config);

    return ref.onClose.pipe(
      map((_document: DocumentDTO) => {
        if (_document) {
          let relatedDocument = new RelatedDocumentDTO();
          relatedDocument.document = _document;
          relatedDocument.readOnly = false;
          relatedDocument.visible = true;
          /*relatedDocument.relation = <MasterDataDTO>{
            identifier: 'DOCCONTABLE_DOCELEC<>ASOCIADOCCONTABLE_DOCELEC'
          };*/
          relatedDocument.relation = <MasterDataDTO>{
            identifier: '10<>TIPOS_ASOCIADOCS'
          };
          return relatedDocument;
        }
      }),
      catchError((error: any) => {
        this.plycaErrorHandler.showServerError(error);
        return throwError(error);
      })
    );
  }

  getLabelInvoiceDetailLine(invoice: InvoiceDTO, invoiceDetailLine: InvoiceDetailLineDTO): string {
    let separador = ' | ';
    let label = invoice.number + ((invoice.serialNumber != null && invoice.serialNumber !== '') ? (separador + invoice.serialNumber) : '')
      + separador + invoiceDetailLine.budget.taxType.description;
    return label;
  }

  getLabelBudgetAccountLine(budgetAccountLine: BudgetAccountLineDTO): string {
    let separador = ' | ';
    let label = budgetAccountLine.year + ' | ' + budgetAccountLine.organic + separador + budgetAccountLine.functional + separador + budgetAccountLine.economical;

    if (budgetAccountLine.investnmentProject != null && budgetAccountLine.investnmentProject !== '') {
      label = label.concat(separador + budgetAccountLine.investnmentProject);
    }
    if (budgetAccountLine.remittance != null && budgetAccountLine.remittance !== '') {
      label = label.concat(separador + budgetAccountLine.remittance);
    }
    if (budgetAccountLine.fixedAssetNumber != null && budgetAccountLine.fixedAssetNumber !== '') {
      label = label.concat(separador + budgetAccountLine.fixedAssetNumber);
    }
    if (budgetAccountLine.budget) {
      label = label.concat(separador + budgetAccountLine.budget.totalAmount);
    }
    return label;
  }

  addBudgetAccountLineInvoiceDiscount(row: BudgetAccountLineInvoiceAssociationDTO) {
    if (this.model.ui.budgetAccountLineInvoiceAssociates == null || this.model.ui.budgetAccountLineInvoiceAssociates.length < 1) {
      this.uiService.showMessage('Para poder asociar un descuento debe informar previamente al menos una posición presupuestaria', 'Validación', 'errorStyle');
      return;
    }

    let parametersURL: ActionParameterDefinitionDTO[] = [];

    let param1 = new ActionParameterDefinitionDTO();
    param1.identifier = 'NIT';
    param1.value = this.model.dto.interested.externalIdentifier;
    parametersURL.push(param1);

    let param2 = new ActionParameterDefinitionDTO();
    param2.identifier = 'SOCIEDAD';
    param2.value = this.model.ui.societyIdentifier;
    parametersURL.push(param2);

    let completedResult = true;
    let autoSearch = true;
    let contextSearch = new SearchSettingDTOModal(
      'INTEGRATIONRETENCIONES',
      autoSearch,
      parametersURL,
      completedResult
    );



    let config: DynamicDialogConfig = {
      header: 'Asociación de descuentos a la posición presupuestaria: ' + this.getLabelBudgetAccountLine(row.budgetAccountLine) + '; ' + this.getLabelInvoiceDetailLine(row.invoice, row.invoiceDetailLine),
      width: '70%',
      style: { overflow: 'scroll', 'max-height': '80%' }
    };
    config['context'] = contextSearch;
    config['showWait'] = true;
    let ref = this.dialogService.open(searchGenericComponent, config);

    this.subscribe(
      ref.onClose.pipe(
        tap((discountSelected: BudgetAccountLineInvoiceDiscountAssociationDTO) => {
          if (discountSelected) {
            discountSelected.budgetAccountLine = row.budgetAccountLine;
            discountSelected.invoice = row.invoice;
            discountSelected.invoiceDetailLine = row.invoiceDetailLine;
            discountSelected.totalAmount = 0;
            discountSelected.taxBaseAmount = 0;

            /*let existsDiscont = false;
            for (let discount of this.model.ui.budgetAccountLineInvoiceDiscountAssociates) {
              if (
                (discount.budgetAccountLine.identifier === discountSelected.budgetAccountLine.identifier)
                && (discount.invoice.number === discountSelected.invoice.number)
                && (
                  // if (color !== null)   console.log('value is NOT equal to null');
                  ((discount.invoice.serialNumber == null || (discount.invoice.serialNumber != null && discount.invoice.serialNumber === ''))
                    && (discountSelected.invoice.serialNumber == null || (discountSelected.invoice.serialNumber != null && discountSelected.invoice.serialNumber === ''))
                  )
                  || (discount.invoice.serialNumber === discountSelected.invoice.serialNumber)
                )
                && (discount.invoiceDetailLine.budget.taxType.identifier === discountSelected.invoiceDetailLine.budget.taxType.identifier)
                && (discount.discountType.identifier === discountSelected.discountType.identifier)
              ) {
                existsDiscont = true;
              }
            }*/
            let discount = this.existsDiscont(discountSelected);

            if (discount != null) {
              this.uiService.showMessage('El descuento seleccionado ya se encuentra asociado a una posición presupuestaria en el documento contable, para poder realizar esta operación debe borrar previamente el descuento asociado a la posición presupestaria del documento contable.', this.translationService.instant('General.error'));
            } else {
              this.model.ui.budgetAccountLineInvoiceDiscountAssociates.push(discountSelected);
              this.setAmountDiscount();
            }
          }
        }),
        catchError((error: any) => {
          this.plycaErrorHandler.showServerError(error);
          return throwError(error);
        })
      )
    );

    return ref.onClose.pipe(
      /* map((_searchResult: SearchSelectionResultDTO) => {
         if (_searchResult && _searchResult.result) {
           let tipoRetencion: MasterDataDTO = _searchResult.result;
           return tipoRetencion;
         }
       }),
       catchError((error: any) => {
         this.plycaErrorHandler.showServerError(error);
         return throwError(error);
       })*/
      map((discount: BudgetAccountLineInvoiceDiscountAssociationDTO) => {
        /*map((invoiceDetailLineSelected: InvoiceDetailLineDTO) => {

          if (invoiceDetailLineSelected) {

            let budgetAccountLineInvoiceAssociation = new BudgetAccountLineInvoiceAssociationDTO();

            // identifier: string;
              //invoiceDetailLine: InvoiceDetailLineDTO; // MATERIALSOLICITADOID
              //invoice: InvoiceDTO;
              //budgetAccountLine: BudgetAccountLineDTO;
              //totalAmount: number;
              //taxType: MasterDataDTO; // Tipo de Impuesto   ID_IMPUESTO
              //totalTaxes: number;
              // Retenciones asociadas
              //budgetAccountLineInvoiceDiscountAssociates: BudgetAccountLineInvoiceDiscountAssociationDTO[];

            budgetAccountLineInvoiceAssociation.invoice = invoiceDetailLineSelected.entity;

            budgetAccountLineInvoiceAssociation.invoiceDetailLine = invoiceDetailLineSelected;

            let invoiceDetailLineBudget: InvoiceDetailLineBudgetDTO = invoiceDetailLineSelected.budget;
            //MasterDataDTO taxType; // Tipo de Impuesto   ID_IMPUESTO

            //Double unitAmount; // Importe por unidad  IMPORTE_UNIDAD
            //Double amountExcludingTaxes; // Importe sin IVA IMPORTE_NETO
            //Double totalTaxes; // Importe del IVA    IMPORTEIMPUESTO
            //Double totalAmount; // Importe bruto IMPORTEBRUTO

            budgetAccountLineInvoiceAssociation.totalTaxes = invoiceDetailLineBudget.totalTaxes;
            budgetAccountLineInvoiceAssociation.totalAmount = invoiceDetailLineBudget.totalAmount;
            budgetAccountLineInvoiceAssociation.taxType = invoiceDetailLineBudget.taxType;

            let i = 0;
            let budgetAccountLine: BudgetAccountLineDTO = this.model.dto.budget.budgetAccountLine[i];
            budgetAccountLineInvoiceAssociation.budgetAccountLine = budgetAccountLine;
            return budgetAccountLineInvoiceAssociation;
          }
        })*/

        if (discount) {

          let i = 0;
          let budgetAccountLineInvoice: BudgetAccountLineInvoiceAssociationDTO = this.model.ui.budgetAccountLineInvoiceAssociates[i];
          discount.budgetAccountLine = budgetAccountLineInvoice.budgetAccountLine;
          discount.invoice = budgetAccountLineInvoice.invoice;
          discount.invoiceDetailLine = budgetAccountLineInvoice.invoiceDetailLine;
          discount.totalAmount = 0;
          discount.taxBaseAmount = 0;

          /*identifier: string;
          invoiceDetailLine: InvoiceDetailLineDTO; // MATERIALSOLICITADOID
          invoice: InvoiceDTO;
          budgetAccountLine: BudgetAccountLineDTO;
          discountType: MasterDataDTO;
          totalAmount: number;
          taxType: MasterDataDTO;
          taxBaseAmount: number;*/

          return discount;
        }
      }),
      catchError((error: any) => {
        this.plycaErrorHandler.showServerError(error);
        return throwError(error);
      })





    );

  }

  existsDiscont(discountSelected: BudgetAccountLineInvoiceDiscountAssociationDTO): BudgetAccountLineInvoiceDiscountAssociationDTO {

    let existsDiscont = false;

    for (let discount of this.model.ui.budgetAccountLineInvoiceDiscountAssociates) {
      if (
        (discount.budgetAccountLine.identifier === discountSelected.budgetAccountLine.identifier)
        && (discount.invoice.number === discountSelected.invoice.number)
        && (
          // if (color !== null)   console.log('value is NOT equal to null');
          ((discount.invoice.serialNumber == null || (discount.invoice.serialNumber != null && discount.invoice.serialNumber === ''))
            && (discountSelected.invoice.serialNumber == null || (discountSelected.invoice.serialNumber != null && discountSelected.invoice.serialNumber === ''))
          )
          || (discount.invoice.serialNumber === discountSelected.invoice.serialNumber)
        )
        && (discount.invoiceDetailLine.budget.taxType.identifier === discountSelected.invoiceDetailLine.budget.taxType.identifier)
        && (discount.discountType.identifier === discountSelected.discountType.identifier)
      ) {
        return discount;
      }
    }
    return null;
  }

  removeBudgetAccountLineInvoiceAssociation(model: any, index: any, budgetAccountLineInvoice: BudgetAccountLineInvoiceAssociationDTO) {

    let identifierBudgetAccountLine = budgetAccountLineInvoice.budgetAccountLine.identifier;
    let identifierInvoiceDetailLine = budgetAccountLineInvoice.invoiceDetailLine.identifier;

    if (model.ui.budgetAccountLineInvoiceDiscountAssociates) { // BudgetAccountLineInvoiceDiscountAssociationDTO[]

      let budgetAccountLineInvoiceDiscountAssociatesFiltered = model.ui.budgetAccountLineInvoiceDiscountAssociates.filter(
        action => action
          && action.budgetAccountLine.identifier === identifierBudgetAccountLine
          && action.invoiceDetailLine.identifier === identifierInvoiceDetailLine
      );
      if (budgetAccountLineInvoiceDiscountAssociatesFiltered.length > 0) {
        let message = '<ul>';
        for (let budgetAccountLineInvoiceDiscountAssociates of budgetAccountLineInvoiceDiscountAssociatesFiltered) {
          let discountType = budgetAccountLineInvoiceDiscountAssociates.discountType.description;

          message += '<li>' + discountType + '</li>';

        }
        message += '</ul>';

        let numberInvocie = budgetAccountLineInvoice.invoice.number;
        let serialNumberInvocie = budgetAccountLineInvoice.invoice.serialNumber;
        let taxType = budgetAccountLineInvoice.invoiceDetailLine.budget.taxType.description;

        this.uiService.showMessage('La partida, ' + budgetAccountLineInvoice.budgetAccountLine.label +
          ', con la factura, ' + numberInvocie + ' ' + serialNumberInvocie + ' ' + taxType +
          ', no se puede borrar porque está asociada a los siguientes descuentos:' + message, 'Validación', 'errorStyle');
        return false;
      }
    }
    return true;
  }

  removeBudgetAccountLine(model: any, index: any, budgetAccountLine: BudgetAccountLineDTO) {
    let identifier = budgetAccountLine.identifier;

    if (model.ui.budgetAccountLineInvoiceAssociates) {  // Array<BudgetAccountLineInvoiceAssociationDTO>

      let budgetAccountLineInvoiceAssociatesFiltered = model.ui.budgetAccountLineInvoiceAssociates.filter(
        action => action && action.budgetAccountLine && action.budgetAccountLine.identifier === identifier
      );

      if (budgetAccountLineInvoiceAssociatesFiltered.length > 0) {
        let budgetAccountLineLabel = '';
        let message = '<ul>';
        for (let budgetAccountLineInvoiceAssociate of budgetAccountLineInvoiceAssociatesFiltered) {

          let numberInvocie = budgetAccountLineInvoiceAssociate.invoice.number;
          let serialNumberInvocie = budgetAccountLineInvoiceAssociate.invoice.serialNumber;

          let taxType = budgetAccountLineInvoiceAssociate.invoiceDetailLine.budget.taxType.description;

          budgetAccountLineLabel = budgetAccountLineInvoiceAssociate.budgetAccountLine.label;

          message += '<li>Factura: ' + numberInvocie + ' ' + serialNumberInvocie + ' ' + taxType + '</li>';
        }
        message += '</ul>';
        this.uiService.showMessage('La partida, ' + budgetAccountLineLabel + ', no se puede borrar porque está asociada a las siguientes facturas:' + message, 'Validación', 'errorStyle');
        return false;
      }
    }
    return true;
  }

  onChangeRowRemoveBudgetAccountLine(model: any, index: any, budgetAccountLineI: BudgetAccountLineDTO) {
    this.setAmountWithTaxesBudgetAccountLine(model);
  }

  removeBudgetAccountLineInvoice(model: any, index: any, budgetAccountLineInvoiceAssociate: BudgetAccountLineInvoiceAssociationDTO) {
    this.setAmountInvoice(model);
  }

  removeBudgetAccountLineInvoiceDiscount(model: any, index: any, budgetAccountLineInvoiceDiscountAssociate: BudgetAccountLineInvoiceDiscountAssociationDTO) {
    this.setAmountDiscount(model);
  }

  addBudgetAccountLine(model: any) {
    let budgetAccountLine: BudgetAccountLineDTO = new BudgetAccountLineDTO();
    let cliente = this.appConfig.getValue('cliente');
    //cliente = 'AYMAD';
    if ('AYMAD' === cliente && model.ui.isFaseO) {
      budgetAccountLine.identifier = this.generateNumber();
    }
    return budgetAccountLine;
  }

  generateNumber(): number {
    return -1 * (Math.floor(Math.random() * 999999) + 1);
  }

  ////////////////////////////////////////////////////////////////////////////////////////////////////
  ///// this.model -> definición de la function -> bind (this);  // model -> formelement -> row  /////
  ////////////////////////////////////////////////////////////////////////////////////////////////////
  addBudgetAccountLineInvoice(row: BudgetAccountLineDTO) {
    if (this.model.dto.budget.budgetAccountLine == null || this.model.dto.budget.budgetAccountLine.length < 1) {
      this.uiService.showMessage('Para poder asociar una factura debe informar previamente al menos una partida presupuestaria', 'Validación', 'errorStyle');
      return;
    } else if (this.model.ui.integrationNITCompanyDocInterested.externalIdentifier == null) {
      this.uiService.showMessage('Para poder asociar una factura debe informar previamente el NIT del interesado', 'Validación', 'errorStyle');
      return;
    }

    let parametersURL: ActionParameterDefinitionDTO[] = [];

    let param1 = new ActionParameterDefinitionDTO();
    param1.identifier = 'EMPRESADNICIF';
    param1.value = this.model.dto.interested.taxIdentifier;
    parametersURL.push(param1);

    let param2 = new ActionParameterDefinitionDTO();
    param2.identifier = 'NIT';
    param2.value = this.model.dto.interested.externalIdentifier;
    parametersURL.push(param2);

    let param3 = new ActionParameterDefinitionDTO();
    param3.identifier = 'DIVISION_CONTRATO';
    let divisionContrato = getSimpleIdentifierFromString(this.model.ui.award.division.identifier);
    param3.value = divisionContrato;
    parametersURL.push(param3);

    let param4 = new ActionParameterDefinitionDTO();
    param4.identifier = 'INTERESTED_NAME';
    param4.value = this.model.dto.interested.name;
    parametersURL.push(param4);

    let param5 = new ActionParameterDefinitionDTO();
    param5.identifier = 'DOSSIERID';
    param5.value = this.model.ui.dossierId;
    parametersURL.push(param5);

    let param6 = new ActionParameterDefinitionDTO();
    param6.identifier = 'EXPEDIENTEID';
    param6.value = this.model.dto.division.project.contractFolderId;
    parametersURL.push(param6);

    let param7 = new ActionParameterDefinitionDTO();
    param7.identifier = 'NUMTRAMITE';
    let numTramite = getSimpleIdentifierFromString(this.task.procedure.identifier);
    param7.value = numTramite;
    parametersURL.push(param7);

    let param8 = new ActionParameterDefinitionDTO();
    param8.identifier = 'NUMORDEN_DOCCONTABLE';
    param8.value = this.model.dto.orderNumber;
    parametersURL.push(param8);

    let param9 = new ActionParameterDefinitionDTO();
    param9.identifier = 'DIVISION_DOCCONTABLE';
    param9.value = getSimpleIdentifierFromString(this.model.dto.division.identifier);
    parametersURL.push(param9);

    let param10 = new ActionParameterDefinitionDTO();
    param10.identifier = 'LISTADOCID_DOCCONTABLE';
    param10.value = this.model.dto.documentClass.identifier;
    parametersURL.push(param10);

    let completedResult = true;
    let autoSearch = true;
    let contextSearch = new SearchSettingDTOModal(
      'INTEGRATIONINVOICES',
      autoSearch,
      parametersURL,
      completedResult
    );

    let config: DynamicDialogConfig = {
      header: 'Asociación de facturas a la partida: ' + this.getLabelBudgetAccountLine(row),
      width: '70%',
      style: { overflow: 'scroll', 'max-height': '80%' }
    };

    config['context'] = contextSearch;
    config['showWait'] = true;
    // Acciones de la tabla de resultados



    let rowActions: FieldAction[] = new Array();
    let rowAction = new FieldAction();
    // Ver factura
    rowAction.functionName = 'showInvoicePdf';
    rowAction.imageClass = 'fas fa-file-pdf';
    rowAction.buttonTextKey = 'ExpenseDocument.actions.showInvoice';
    rowAction.enabled = 'this.invoice?.document?.currentVersion?.externalIdentifier';
    rowActions.push(rowAction);
    // Ver anexos
    rowAction = new FieldAction();
    // Ver factura
    rowAction.functionName = 'showAttachFiles';
    rowAction.imageClass = 'fas fa-paperclip';
    rowAction.buttonTextKey = 'ExpenseDocument.actions.showAttachFiles';
    rowAction.enabled = 'this.invoice?.invoiceExternalFiles?.length>0';
    rowActions.push(rowAction);

    config['rowActions'] = rowActions;


    let rowActionsFunctions: Array<FunctionDef> = new Array();
    rowActionsFunctions.push({
      identifier: 'showInvoicePdf',
      fn: this.showInvoicePdf.bind(this) // Para tener acceso al documentService
    });

    rowActionsFunctions.push({
      identifier: 'showAttachFiles',
      fn: this.showAttachFiles.bind(this)  // Para tener acceso al documentService
    });
    config['rowActionsFunctions'] = rowActionsFunctions;

    let ref = this.dialogService.open(searchGenericComponent, config);

    this.subscribe(
      ref.onClose.pipe(
        tap((budgetAccountLineInvoiceAssociationSelected: BudgetAccountLineInvoiceAssociationDTO) => {
          if (budgetAccountLineInvoiceAssociationSelected) {
            budgetAccountLineInvoiceAssociationSelected.budgetAccountLine = row;

            let existsBudgetAccountLineInvoice = false;
            for (let budgetAccountLineInvoiceAssociates of this.model.ui.budgetAccountLineInvoiceAssociates) {
              if (
                (budgetAccountLineInvoiceAssociates.budgetAccountLine.identifier === budgetAccountLineInvoiceAssociationSelected.budgetAccountLine.identifier)
                && (budgetAccountLineInvoiceAssociates.invoice.number === budgetAccountLineInvoiceAssociationSelected.invoice.number)
                && (
                  // if (color !== null)   console.log('value is NOT equal to null');
                  ((budgetAccountLineInvoiceAssociates.invoice.serialNumber == null || (budgetAccountLineInvoiceAssociates.invoice.serialNumber != null && budgetAccountLineInvoiceAssociates.invoice.serialNumber === ''))
                    && (budgetAccountLineInvoiceAssociationSelected.invoice.serialNumber == null || (budgetAccountLineInvoiceAssociationSelected.invoice.serialNumber != null && budgetAccountLineInvoiceAssociationSelected.invoice.serialNumber === ''))
                  )
                  || (budgetAccountLineInvoiceAssociates.invoice.serialNumber === budgetAccountLineInvoiceAssociationSelected.invoice.serialNumber)
                )
                && (budgetAccountLineInvoiceAssociates.taxType.identifier === budgetAccountLineInvoiceAssociationSelected.taxType.identifier)
              ) {
                existsBudgetAccountLineInvoice = true;
              }
            }
            if (existsBudgetAccountLineInvoice) {
              this.uiService.showMessage('El detalle de la factura seleccionada ya existe asociado  a esta partida en el documento contable, para poder realizar esta operación debe borrar el detalle de la factura previamente del documento contable.', this.translationService.instant('General.error'));
            } else {
              this.model.ui.budgetAccountLineInvoiceAssociates.push(budgetAccountLineInvoiceAssociationSelected);
              this.setAmountInvoice();
              // Si el detalle de la factura tiene descuentos los gestionamos
              if (budgetAccountLineInvoiceAssociationSelected && budgetAccountLineInvoiceAssociationSelected.budgetAccountLineInvoiceDiscountAssociates) {
                for (let discount of budgetAccountLineInvoiceAssociationSelected.budgetAccountLineInvoiceDiscountAssociates) {
                  discount.budgetAccountLine = row;
                  let discountTable = this.existsDiscont(discount);
                  if (discountTable != null) { // Si ya existe lo machacamos!!
                    discountTable = discount;
                  } else { // Si no existe lo añadimos
                    this.model.ui.budgetAccountLineInvoiceDiscountAssociates.push(discount);
                  }
                }
                this.setAmountDiscount();
              }
            }

          }
        }),
        catchError((error: any) => {
          this.plycaErrorHandler.showServerError(error);
          return throwError(error);
        })
      )
    );
  }

  addInvoice() {
    let parametersURL: ActionParameterDefinitionDTO[] = [];

    let param1 = new ActionParameterDefinitionDTO();
    param1.identifier = 'FACTURAS.FAC_PROPUESTAID';
    // revisar!! porque en ejecución no lo reconoce como una función válida
    // Pendiente de probar: Tampoco funciona. La razón es porque  this es un formElementComponent
    // param1.value = this.normalizaDossierId.apply(this, this.model.ui.dossierId).bind(this);

    param1.value = this.model.ui.dossierId.substring(0, 4) + '/' + this.model.ui.dossierId.substring(4);
    parametersURL.push(param1);
    // Se comenta establecer el filtro para no limitar la búsqueda a la division del documento contable O. Debería poder elegir cualquier
    // factura creada en la división del O y divisones padres hasta el llegal al contrato
    // Cuando se establece el filtro de la división el buscado ejecuta la siguiente quer:
    /*BusquedaDAO.executeQuery.query ejecutada:
      SELECT
          FACTURAS.UUID,FACTURAS.EMPRESADNICIF,FACTURAS.FACTURANUM,FACTURAS.FACTFECHA,FACTURAS.TOTALMAX,
          FACTURAS.TOTAL_MENOS_USADO,FACTURAS.num_registro_contable FROM gg_view_sumfact_liquido FACTURAS
      WHERE  1=1
          and UPPER(translate(FACTURAS.FAC_PROPUESTAID, 'áéíóúÁÉÍÓÚ?', 'aeiouAEIOU'))
          LIKE UPPER(translate('%2018/0002000013%', 'áéíóúÁÉÍÓÚ', 'aeiouAEIOU'))
          and UPPER(FACTURAS.FAC_LOTEID) IN ('1')
          AND FACTURAS.total_menos_usado <> 0
      ORDER BY FACTURAS.factfecha
      */


    /*  public getBuscadorBuzonesConfig(): FieldConfig {
  let config = new FieldConfig();
  config.type = 'SEARCH';
  config.jsonField = 'inbox';
  config.description = '';
  config.autoSearch = false;
  config.idBuscador = 'INBOX';
  config.parameters =
    "[{'identifier': 'PERFILBUZON.PERID','value':'' + step.profile.identifier + ''},
    {'identifier': 'BUZON.USUARIOSNOBLOQUEADOS','value':'true'},
    {'identifier': 'PERFILBUZON.APLICACION','value':''CONTRATACION''},
    {'identifier': 'ORGANISMO.RUTA','value':''' +  dossier.division.project.organizationalUnit.identifier + ''' }]";
  return config;
  }*/

    let param2 = new ActionParameterDefinitionDTO();
    param2.identifier = 'FACTURAS.FAC_LOTEID';
    param2.value = this.model.ui.docDivisionId;
    if (this.model.ui.award && this.model.ui.award.division) {
      let divisionIdAward = getSimpleIdentifierFromString(this.model.ui.award.division.identifier);
      if (divisionIdAward != param2.value) {
        param2.value = divisionIdAward + ',' + param2.value;
      }
    }
    parametersURL.push(param2);

    let invoicesAssociation = this.model.dto.expenseDocumentInvoiceAssociation;
    let excludedInvoices = '';
    if (invoicesAssociation) {
      for (let i in invoicesAssociation) {
        let associatedInvoice = invoicesAssociation[i].associatedInvoice;
        if (associatedInvoice) {
          if (excludedInvoices && excludedInvoices !== '') {
            excludedInvoices = excludedInvoices + '\',\'';
          }
          excludedInvoices = excludedInvoices + associatedInvoice.identifier;
        }
      }
    }
    if (excludedInvoices && excludedInvoices !== '') {
      let param3 = new ActionParameterDefinitionDTO();
      param3.identifier = 'FACTURAS_CAPTURADAS.UUID';
      param3.value = excludedInvoices;
      parametersURL.push(param3);
    }

    let completedResult = true;
    let autoSearch = false;
    let contextSearch = new SearchSettingDTOModal(
      'FACTURAS',
      autoSearch,
      parametersURL,
      completedResult
    );
    let config: DynamicDialogConfig = {
      header: '',
      width: '70%',
      style: { overflow: 'scroll', 'max-height': '80%' }
    };
    config['context'] = contextSearch;
    let ref = this.dialogService.open(searchGenericComponent, config);
    return ref.onClose.pipe(
      map((_searchResult: SearchSelectionResultDTO) => {

        if (_searchResult && _searchResult.result) {
          let totalMenosUsado = 0;
          if (_searchResult.content && _searchResult.content.TOTAL_MENOS_USADO) {
            totalMenosUsado = _searchResult.content.TOTAL_MENOS_USADO.value;

          }
          let invoiceAssociation = new ExpenseDocumentInvoiceAssociationDTO();

          invoiceAssociation.associatedInvoice = _searchResult.result;
          /* @MapColumn(from = "expenseDocument.division.identifier.parent.identifier", function = MappingFunction.NORMALIZE)
          // Es lo mismo que: expenseDocument.division.project.identifier
           DOCCON_PROPUESTAID,
           @MapColumn(from= "expenseDocument.division.identifier.id")
           DOCCON_LOTEID,
           @MapColumn(from = "expenseDocument.orderNumber")
           DOCCON_NUMORDEN,
           @MapColumn(from= "expenseDocument.documentClass.identifier")*/

          let accountingDocument = new AccountingDocumentDTO();
          accountingDocument.documentClass = this.model.dto.documentClass;
          accountingDocument.division = this.model.dto.division;
          accountingDocument.orderNumber = this.model.dto.orderNumber;

          invoiceAssociation.expenseDocument = accountingDocument;
          let invoiceDetailLineDTO = new InvoiceDetailLineDTO();
          invoiceAssociation.associatedInvoiceDetailLine = invoiceDetailLineDTO;
          invoiceAssociation.associatedTotalAmount = totalMenosUsado;

          console.log('INVOICE ANNADIDA: ', invoiceAssociation.associatedInvoice.number);
          return invoiceAssociation;
        }
      }),
      catchError((error: any) => {
        this.plycaErrorHandler.showServerError(error);
        return throwError(error);
      })
    );
  }
  /*canDeactivate(): boolean | Observable<boolean> | Promise<boolean> {
    if (!this.modalOpened) {
      if (this.task && this.task.work) {
        this.task.work = JSON.parse(
          JSON.stringify(this.task.work, (k, v) => (k === '_parent' ? undefined : v))
        );
      }
      return super.canDeactivate();
    }
    return false;
  }

  processTask(reactivate = false) {
    //this.task.work.expenseDocument = this.modelToDTO(this.model);
    this.task.work.expenseDocument = this.modelToDTO(lodash.cloneDeep(this.model))
    super.processTask(reactivate);
  }*/

  protected getTask(): TaskDTO {
    /*let tmpTask = lodash.cloneDeep(this.task);
    //tmpTask.work.expenseDocument = this.modelToDTO(lodash.cloneDeep(this.model));
    let model = new AccountingDocumentModel();
    model.dto = tmpTask.work.expenseDocument;
    model.ui = {};
    tmpTask.work.expenseDocument = this.modelToDTO(model);
    return tmpTask;*/

    // Finalmente se opta por esta dolución para evitar model.ui = {}
    this.task.work.expenseDocument = this.modelToDTO(this.model);
    // Para hacerlo generico: this.task.work['expenseDocument'] = this.modelToDTO(this.model);
    return this.task;

  }

  private patchExpenseDocumentIndexNumber(): Observable<any> {
    let patchedAccountingDocument = new AccountingDocumentDTO();
    patchedAccountingDocument.indexNumber = this.model.dto.indexNumber;

    let modifiedDto = this.modelToDTO(lodash.cloneDeep(this.model));
    let documentPatch = modifiedDto.document;
    patchedAccountingDocument.document = documentPatch;
    patchedAccountingDocument.task = this.task;
    patchedAccountingDocument.identifier = this.identifier;

    return this.plycaService.patch<AccountingDocumentDTO>(
      this.getServiceURL(),
      patchedAccountingDocument
    );
  }


  openAtributeDialog() {
    this.subscribe(this.plycaService.getAttributeValue(
      'ERRORES_INTEGRACION_SISTEMA_CONTABLE',
      /*'PROPUESTAID=2018/0002000013'
      + '&LOTEID=1'
      + '&LISTADOCID=00010'
      + '&DOCCONTABLENUMORDEN=3'*/
      'PROPUESTAID=' + this.model.ui.dossierId.substring(0, 4) + '/' + this.model.ui.dossierId.substring(4)
      + '&LOTEID=' + this.model.ui.docDivisionId
      + '&LISTADOCID=' + this.model.dto.documentClass.identifier
      + '&DOCCONTABLENUMORDEN=' + this.model.dto.orderNumber
    ), x => {
      let config: DynamicDialogConfig = {
        header: 'Errores de integración',
        width: '75%',
        style: { overflow: 'hidden', 'max-height': '70vh' },
        styleClass: 'searchStyle'
      };
      config['attributeValues'] = x;
      config['identifier'] = 'ERRORES_INTEGRACION_SISTEMA_CONTABLE';
      const dialog = this.dialogService.open(tableComponent, config);
      dialog.onClose.pipe(take(1)).subscribe(() => {
        this.subscribe(this.helpService.showContextHelpObservable(HelpType.HELP_TASKS));
      });
    });
  }

  addSaveButton() {
    if (this.task && this.task.work && this.task.work.context.configurations['accionTask'] && this.task.work.context.configurations['accionTask'].value === '__DATOS_ASOC') {
      this.subscribe(this.headerActionsService
        .addWindowAction(
          'General.save',
          //'save - patchExpenseDocumentIndexNumber',
          'fas fa-save',
          'btn-primary',
          true,
          this.windowHash
        ), () => {
          this.waitService.startWaiting();
          this.subscribe(this.patchExpenseDocumentIndexNumber(),
            () => {
              this.ref.close(this.model);
            },
            (error: any) => {
              this.manageActionError(error, true);
              this.waitService.cancelWaiting();
            }
          );
        });
    } else if (!this.model.ui.isValidateAccionTask) {
      this.subscribe(this.headerActionsService
        .addWindowAction(
          'General.save',
          //'save - plycaService.update',
          'fas fa-save',
          'btn-primary',
          true,
          this.windowHash
        ),
        () => {
          this.waitService.startWaiting();
          this.subscribe(this.save(false),
            () => {
              this.ref.close(this.model);
            },
            (error: any) => {
              this.waitService.cancelWaiting();
            }
          );
        });
    }
  }

  changeDossierDescription(model: any, changes?: any) {
    console.log('EJECUTADO changeDossierDescription', model, changes);
    let reset = this.resetChangeDossierDescription(changes);

    let newValue = new SearchSelectionResultDTO();
    newValue = changes.newValue;
    if (reset) {
      this.model.ui.procedureActionDossier_typeAction_SearchGenericResult = undefined;
      this.model.ui.procedureActionDossier_typeProcedure_SearchGenericResult = undefined;

      if (newValue === undefined) {
        this.model.ui.isEditableActionDescription = false;
      } else {
        this.model.ui.isEditableActionDescription = true;

      }
      this.model.ui.isEditableProcedureDescription = false;
    } else {
      if (newValue && newValue.content && newValue.content.TIPO_EXPTE_ID && newValue.content.TIPO_EXPTE_ID.value
        && newValue.content.TIPO_EXPTE_ID.value !== '') {
        this.model.ui.isEditableActionDescription = true;
        this.model.ui.isEditableProcedureDescription = false;
      }
    }
  }

  resetChangeDossierDescription(changes?: any) {
    let oldValue = new SearchSelectionResultDTO();
    oldValue = changes.oldValue;
    let newValue = new SearchSelectionResultDTO();
    newValue = changes.newValue;

    let reset = ((oldValue && newValue) && (oldValue.content && newValue.content)
      && (oldValue.content.TIPO_EXPTE_ID && newValue.content.TIPO_EXPTE_ID)
      && (oldValue.content.TIPO_EXPTE_ID.value != newValue.content.TIPO_EXPTE_ID.value)) || (newValue === undefined);
    console.log('======resetChangeDossierDescription', reset);
    return reset;
  }

  changeActionDescription(model: any, changes?: any) {
    console.log('EJECUTADO changeActionDescription', model, changes);
    let newValue = new SearchSelectionResultDTO();
    newValue = changes.newValue;
    let reset = this.resetChangeActionDescription(changes);

    if (reset) {
      this.model.ui.procedureActionDossier_typeProcedure_SearchGenericResult = undefined;
      if (newValue === undefined) {
        this.model.ui.isEditableProcedureDescription = false;
      } else {
        this.model.ui.isEditableProcedureDescription = true;
      }
    } else {
      if (newValue && newValue.content && newValue.content.ACTUACION_ID && newValue.content.ACTUACION_ID.value
        && newValue.content.ACTUACION_ID.value !== '') {
        this.model.ui.isEditableProcedureDescription = true;
      }
    }
    if (this.model.ui.isEditableProcedureDescription) {
      this.setEditableProcedureDescription(
        this.model.ui.procedureActionDossier_typeDossier_SearchGenericResult.content.TIPO_EXPTE_ID.value, this.model.ui.procedureActionDossier_typeAction_SearchGenericResult.content.ACTUACION_ID.value);
    }
  }

  setEditableProcedureDescription(typeDossier: string, action: string) {
    this.subscribe(this.plycaService.query<ProcedureActionDossierDTO>(
      this.configuration.PROCEDURE_ACTION_DOSSIERS_SERVICE_URL,
      {
        typeDossierId: typeDossier,
        actionId: action
      }
    ), (result: PaginationDTO<ProcedureActionDossierDTO>) => {
      if (result !== null && result.content && result.content.length == 1) {
        console.log('CONSULTA REALIZADA: Un registro', result.content.length);
        this.model.ui.isEditableProcedureDescription = false;
      }
      this.waitService.cancelWaiting();
    });
  }

  resetChangeActionDescription(changes?: any) {
    let oldValue = new SearchSelectionResultDTO();
    oldValue = changes.oldValue;
    let newValue = new SearchSelectionResultDTO();
    newValue = changes.newValue;

    let reset = ((oldValue && newValue) && (oldValue.content && newValue.content)
      && (oldValue.content.ACTUACION_ID && newValue.content.ACTUACION_ID)
      && (oldValue.content.ACTUACION_ID.value != newValue.content.ACTUACION_ID.value)) || (newValue === undefined);
    console.log('======resetChangeActionDescription', reset);
    return reset;
  }

  public defaultValueEligibility(model: any) {
    console.log('======defaultValueEligibility_1', model.elixible);
    if (!model.elixible || model.elixible.identifier === undefined || model.elixible.identifier == '') {
      model.elixible = <MasterDataDTO>{
        identifier: 'N<>TIPO_ELEGIBILIDAD',
        description: 'No'
      };
      console.log('======defaultValueEligibility_2 Le cambio de valor', model.elixible);
    }
    console.log('======defaultValueEligibility_3', model.elixible);
    return model.elixible;
  }


  public openActivoFijoSearch(model: any) {

    // model -> budgetLine
    let parametersURL: ActionParameterDefinitionDTO[] = [];
    let completedResult = true;
    let autoSearch = true;
    let contextSearch = new SearchSettingDTOModal(
      'CLASE_ACTIVO_FIJO',
      autoSearch,
      parametersURL,
      completedResult
    );

    let configActivoFijo: DynamicDialogConfig = {
      header: 'Paso 1: Seleccione la clase de activo fijo.',
      width: '70%',
      style: { 'max-height': '80%' }
    };
    configActivoFijo['context'] = contextSearch;
    configActivoFijo['showWait'] = true;
    let ref = this.dialogService.open(searchGenericComponent, configActivoFijo);
    this.subscribe(
      ref.onClose.pipe(
        tap((result: any) => {

          if (result?.message) {
            this.uiService.showMessage(result.message, this.translationService.instant('General.error'));
          } else {
            if (result) {

              let parametersINTEGRATIONACTIVOFIJO: ActionParameterDefinitionDTO[] = [];

              let param1 = new ActionParameterDefinitionDTO();
              param1.identifier = 'CLASE_ACTIVO';
              param1.value = result;
              parametersINTEGRATIONACTIVOFIJO.push(param1);

              let param2 = new ActionParameterDefinitionDTO();
              param2.identifier = 'SOCIEDAD';
              param2.value = model._parent.ui.societyIdentifier;
              parametersINTEGRATIONACTIVOFIJO.push(param2);

              completedResult = true;
              autoSearch = true;
              contextSearch = new SearchSettingDTOModal(
                'INTEGRATIONACTIVOFIJO',
                autoSearch,
                parametersINTEGRATIONACTIVOFIJO,
                completedResult
              );



              let configSubNumero: DynamicDialogConfig = {
                header: 'Paso 2: Seleccione el activo fijo y el subnúmero.',
                width: '70%',
                style: { 'max-height': '80%' }
              };
              configSubNumero['context'] = contextSearch;
              configSubNumero['showWait'] = true;
              let ref1 = this.dialogService.open(searchGenericComponent, configSubNumero);
              this.subscribe(
                ref1.onClose.pipe(
                  tap((result1: any) => {

                    if (result1?.message) {
                      this.uiService.showMessage(result1.message, this.translationService.instant('General.error'));
                    } else {
                      if (result1) { // Si cancelan no se devuelve elemento seleccionado
                        model.fixedAssetNumber = result1.fixedAssetNumber;
                        model.fixedAssetSubNumber = result1.fixedAssetSubNumber;
                      }
                    }
                  }),
                  catchError((error: any) => {
                    this.plycaErrorHandler.showServerError(error);
                    return throwError(error);
                  })
                )
              );
            } else {
              console.log('Cerrado sin seleccionar');
            }
          }
        }),
        catchError((error: any) => {
          this.plycaErrorHandler.showServerError(error);
          return throwError(error);
        })

      )
    );
  }

  public onChangeOrganismoServicioSearch(model: any, changes?: any) {
    console.log(model);
    console.log(changes);
    // console.log('======onChangeOrganismoServicioSearch.any', model);
    // console.log('======onChangeOrganismoServicioSearch.changes', changes);
  }



  public openMovementType(model: any, changes?: any) {

    let budgetAccountLine: BudgetAccountLineDTO = model;
    let parametersURL: ActionParameterDefinitionDTO[] = [];

    let completedResult = true;
    let autoSearch = true;
    let contextSearch = new SearchSettingDTOModal(
      'CLASE_MOVIMIENTO',
      autoSearch,
      parametersURL,
      completedResult
    );
    //  "searchTitle": "Buscador de clases de movimiento",
    let config: DynamicDialogConfig = {
      header: 'Buscador de servicios.',
      width: '70%',
      style: { 'max-height': '80%' }
    };
    config['context'] = contextSearch;
    config['showWait'] = true;
    let ref = this.dialogService.open(searchGenericComponent, config);
    this.subscribe(
      ref.onClose.pipe(
        tap((result: any) => {
          if (result?.message) {
            this.uiService.showMessage(result.message, this.translationService.instant('General.error'));
          } else {
            if (result) {
              budgetAccountLine.movementType = result;
            } else {
              console.log('Cerrado sin seleccionar');
            }
          }
        }),
        catchError((error: any) => {
          this.plycaErrorHandler.showServerError(error);
          return throwError(error);
        })
      )
    );
  }

  public onChangeIntegrationBankType(model: any, changes?: any) {
    if (changes.newValue) {
      let companyDoc: CompanyDocDTO = changes.newValue;
      this.model.ui.integrationNITCompanyDocInterested.ordinalBank = companyDoc.ordinalBank;
      this.model.ui.integrationNITCompanyDocInterested.bankType = companyDoc.bankType;
    }
  }

  public openBankTypeSearch(model: any, changes?: any) {
    /*
    "id": "interested.bankType",
    "descriptionKey": "Tipo banco del interesado",
    "tooltipText": "Tipo banco del interesado",
    "jsonField": "ui.integrationNITCompanyDocInterested.bankType",
    "type": "SEARCH",
    "searchTitle": "Buscador de tipo de banco",
    "autoSearch": true,
    "editable": "!$functions.isBarrado",
    "idBuscador": "INTEGRATIONBANKTYPE",
    "onChangeFunction": "onChangeIntegrationBankType",
    "parameters": [
      {
        "identifier": "EMPRESADNICIF",
        "value": "this.model.dto.interested.taxIdentifier"
      },
      {
        "identifier": "SOCIEDAD",
        "value": "this.model.ui.societyIdentifier"
      }
    ],
    "visibility": "this.model.ui.isFaseD || this.model.ui.isFaseO",
    "descriptionProperty_old": "bankType",
    "fieldStyle": "col-sm-12  col-md-4"
  },*/

    if (this.model.ui.integrationNITCompanyDocInterested.externalIdentifier === undefined
      || this.model.ui.integrationNITCompanyDocInterested.externalIdentifier == null) {
      this.uiService.showMessage('Para poder realizar la búsqueda es necesario informar previamente el NIT del interesado', 'Validación', 'errorStyle');
      return;
    }

    let parametersURL: ActionParameterDefinitionDTO[] = [];

    let param1 = new ActionParameterDefinitionDTO();
    param1.identifier = 'NIT';
    param1.value = this.model.ui.integrationNITCompanyDocInterested.externalIdentifier;
    parametersURL.push(param1);

    let completedResult = true;
    let autoSearch = true;
    let contextSearch = new SearchSettingDTOModal(
      'INTEGRATIONBANKTYPE',
      autoSearch,
      parametersURL,
      completedResult
    );

    let config: DynamicDialogConfig = {
      header: 'Buscador de tipo banco',
      width: '70%',
      style: { 'max-height': '80%' }
    };
    config['context'] = contextSearch;
    config['showWait'] = true;
    let ref = this.dialogService.open(searchGenericComponent, config);
    this.subscribe(
      ref.onClose.pipe(
        tap((companyDoc: CompanyDocDTO) => {
          /* if (result?.message) {
             this.uiService.showMessage(result.message, this.translationService.instant('General.error'));
           } else {*/
          if (companyDoc) {
            this.model.ui.integrationNITCompanyDocInterested.ordinalBank = companyDoc.ordinalBank;
            this.model.ui.integrationNITCompanyDocInterested.bankType = companyDoc.bankType;
          } else {
            console.log('Cerrado sin seleccionar');
          }
          //}
        }),
        catchError((error: any) => {
          this.plycaErrorHandler.showServerError(error);
          return throwError(error);
        })
      )
    );
  }

  public openOrganicaSearch(model: any, changes?: any) {
    let budgetAccountLine: BudgetAccountLineDTO = model;
    let parametersURL: ActionParameterDefinitionDTO[] = [];

    let param1 = new ActionParameterDefinitionDTO();
    param1.identifier = 'ORGANISMOHEX';
    param1.value = model._parent.dto.division.project.organizationalUnit.identifier;
    parametersURL.push(param1);

    let param2 = new ActionParameterDefinitionDTO();
    param2.identifier = 'ANNO';
    param2.value = model._parent.dto.startYear;
    parametersURL.push(param2);


    let completedResult = true;
    let autoSearch = true;
    let contextSearch = new SearchSettingDTOModal(
      'ORGANISMOSERVICIO_EXPENSEDOCUMENT',
      autoSearch,
      parametersURL,
      completedResult
    );

    let config: DynamicDialogConfig = {
      header: 'Buscador de servicios.',
      width: '70%',
      style: { 'max-height': '80%' }
    };
    config['context'] = contextSearch;
    config['showWait'] = true;
    let ref = this.dialogService.open(searchGenericComponent, config);
    this.subscribe(
      ref.onClose.pipe(
        tap((result: any) => {
          if (result?.message) {
            this.uiService.showMessage(result.message, this.translationService.instant('General.error'));
          } else {
            if (result?.content) {
              budgetAccountLine.year = result.content.ANNO.value;
              budgetAccountLine.organic = result.content.ID_SERVICIO.value;
            } else {
              console.log('Cerrado sin seleccionar');
            }
          }
        }),
        catchError((error: any) => {
          this.plycaErrorHandler.showServerError(error);
          return throwError(error);
        })
      )
    );
  }

  public openPartidasServicioSearch(model: any, changes?: any) {

    /*
    Contenido del model:

        {functional: '11111', year: 2022, exercise: 2022, economical: SearchSelectionResultDTO, entity: {…}, …}
          budget: {totalAmount: 45000}
          economical: SearchSelectionResultDTO
          content: {PRESUPANO: {…}, ANUECONOMICA: {…}, REMESA: {…}, EJERCICIO: {…}, PROYINVID: {…}, …}
          [[Prototype]]: Object
          entity: {division: {…}, extendedDataIdentifier: '2022/001E000001#00002#0#0', orderNumber: 0,
          class: 'com.nexusit.plyca.api.userAPI.v1.document.BaseEntityDTO', documentClass: {…}}
          exercise: 2022
          functional: "11111"
          organic: "001057"
          rowUuid: "b1b839fa-2205-7b0a-cb39-554bf9468561"
          year: 2022
          _parent: AccountingDocumentModel {dto: {…}, ui: {…}}
    */
    /*
    {   oldValue: SearchSelectionResultDTO, newValue: SearchSelectionResultDTO}
          newValue: SearchSelectionResultDTO
            content:
                ANUECONOMICA: {name: 'ANUECONOMICA', value: '62222'}
                ANUFUNCIONAL: {name: 'ANUFUNCIONAL', value: '11111'}
                ANUORGANICA: {name: 'ANUORGANICA', value: '001057'}
                EJERCICIO: {name: 'EJERCICIO', value: '2022'}
                PRESUPANO: {name: 'PRESUPANO', value: '2022'}
                PROYINVID: {name: 'PROYINVID', value: ''}
                REMESA: {name: 'REMESA', value: ''}
              __description: undefined
          oldValue: SearchSelectionResultDTO
            content:
                ANUECONOMICA: {name: 'ANUECONOMICA', value: '22222'}
                ANUFUNCIONAL: {name: 'ANUFUNCIONAL', value: '11111'}
                ANUORGANICA: {name: 'ANUORGANICA', value: '001057'}
                EJERCICIO: {name: 'EJERCICIO', value: '2022'}
                PRESUPANO: {name: 'PRESUPANO', value: '2022'}
                PROYINVID: {name: 'PROYINVID', value: ''}
                REMESA: {name: 'REMESA', value: '5'}
    */
    let budgetAccountLine: BudgetAccountLineDTO = model;
    let parametersURL: ActionParameterDefinitionDTO[] = [];

    let param1 = new ActionParameterDefinitionDTO();
    param1.identifier = 'PROPUESTAID';
    param1.value = model._parent.ui.dossierId;
    parametersURL.push(param1);

    let param2 = new ActionParameterDefinitionDTO();
    param2.identifier = 'EJERCICIO';
    param2.value = model._parent.dto.startYear;
    parametersURL.push(param2);

    let completedResult = true;
    let autoSearch = true;
    let contextSearch = new SearchSettingDTOModal(
      'PARTIDAS',
      autoSearch,
      parametersURL,
      completedResult
    );

    let config: DynamicDialogConfig = {
      header: 'Buscador de partidas presupuestarias.',
      width: '70%',
      style: { 'max-height': '80%' }
    };
    config['context'] = contextSearch;
    config['showWait'] = true;
    let ref = this.dialogService.open(searchGenericComponent, config);
    this.subscribe(
      ref.onClose.pipe(
        tap((result: any) => {

          if (result?.message) {
            this.uiService.showMessage(result.message, this.translationService.instant('General.error'));
          } else {
            if (result) {
              budgetAccountLine.exercise = result.content.EJERCICIO.value;
              budgetAccountLine.year = result.content.PRESUPANO.value;
              budgetAccountLine.organic = result.content.ANUORGANICA.value;
              budgetAccountLine.functional = result.content.ANUFUNCIONAL.value;
              budgetAccountLine.economical = result.content.ANUECONOMICA.value;
              budgetAccountLine.investnmentProject = result.content.PROYINVID.value;
              budgetAccountLine.remittance = result.content.REMESA.value;

            } else {
              console.log('Cerrado sin seleccionar');
            }
          }
        }),
        catchError((error: any) => {
          this.plycaErrorHandler.showServerError(error);
          return throwError(error);
        })
      )
    );
  }

  public onChangeInterestedDNICIF(model: any, changes?: any) {
    console.log('======onChangeInterestedDNICIF.any', model);
    console.log('======onChangeInterestedDNICIF.changes', changes);
    if (changes.newValue) {
      let companyDoc: CompanyDocDTO = changes.newValue;
      this.model.ui.integrationNITCompanyDocInterested.taxIdentifier = companyDoc.taxIdentifier;
      this.model.ui.integrationNITCompanyDocInterested.name = companyDoc.name;
      this.model.ui.integrationNITCompanyDocInterested.address = new AddressDTO();
      if (companyDoc.address) {
        this.model.ui.integrationNITCompanyDocInterested.address.description = companyDoc.address.description;
      }

      this.model.ui.integrationNITCompanyDocInterested.externalIdentifier = null;
    }
  }


  public onChangeIntegrationInterestedNIT(model: any, changes?: any) {
    console.log('======onChangeIntegrationInterestedNIT.any', model);
    console.log('======onChangeIntegrationInterestedNIT.changes', changes);
    if (changes.newValue) {
      let companyDoc: CompanyDocDTO = changes.newValue;
      this.model.ui.integrationNITCompanyDocInterested.name = companyDoc.name;
      this.model.ui.integrationNITCompanyDocInterested.externalIdentifier = companyDoc.externalIdentifier;
      if (this.model.ui.integrationNITCompanyDocInterested.address === undefined) {
        this.model.ui.integrationNITCompanyDocInterested.address = new AddressDTO();
      }
      this.model.ui.integrationNITCompanyDocInterested.address.description = companyDoc.address.name;
    }

    // model: AccountingDocumentModel {dto: {…}, ui: {…}}
    //    dto: {links: Array(1), orderNumber: 1, paymentForm: {…}, expenseDocumentInvoiceAssociation: undefined, document: {…}, …}
    //    ui: {isEditableActionDescription: false, isEditableProcedureDescription: false, dossierId: '2022001E000001',
    // societyIdentifier: 'MDRD', integrationNITCompanyDocInterested: {… }, …
  }
  //
  // changes
  //    {oldValue: '123456789', newValue: {…}}

  public showInvoicePdf(row: any) { // model = formElementComponent  -> _parent = AccountingDocumentModel
    console.log(row);
    let isAttachFile = '0';
    this.waitService.startWaiting();
    if (row.invoice?.document?.currentVersion?.externalIdentifier) {
      this.openFile(row, row.invoice?.document?.currentVersion, isAttachFile);
    }
  }

  //  TOTALES -----------------------------------------------------------------------------------------

  public onChangeAmountWithTaxesBudgetAccountLine(model: any, changes?: any) {
    // model = formElementComponent  -> _parent = AccountingDocumentModel
    if (changes.newValue) {

      let modelParam: AccountingDocumentModel;

      if (model._parent) {
        modelParam = model._parent;
      } else if (this.model) {
        modelParam = this.model;
      }
      // Como estamos en el editorconfig no tenemos el valor actualizado, por tanto, no nos vale con calcular
      // el total sumando los elementos de la tabla.
      let importe = this.getTotalAmountBudget(model._parent);
      importe = (importe + changes.newValue) - changes.oldValue;
      model._parent.ui.totalAmountBudget = importe;
    }
  }

  private setAmountWithTaxesBudgetAccountLine(model?: AccountingDocumentModel) {
    if (model === undefined || model === null) {
      model = this.model;
    }
    let importe = this.getTotalAmountBudget(model);
    model.ui.totalAmountBudget = importe;
  }

  public onChangeAmountInvoice(model: any, changes?: any) {
    // model = formElementComponent  -> _parent = AccountingDocumentModel

    if (changes.newValue == null) {
      changes.newValue = 0;
    }

    // Si se ha cargado la tabla a traves del buscador de facturas,
    // Cuando está provocado por un cambio en el importe de la factura no tenemos model._parent!!
    let modelParam: AccountingDocumentModel;

    if (model._parent) {
      modelParam = model._parent;
    } else if (this.model) {
      modelParam = this.model;
    }
    this.setAmountInvoice(modelParam);
  }

  private setAmountInvoice(model?: AccountingDocumentModel) {
    if (model === undefined || model === null) {
      model = this.model;
    }
    let importe = this.getTotalAmountInvoices(model);
    this.model.ui.totalAmountInvoices = importe;

    let liquid = importe - this.model.ui.totalAmountDiscounts;
    this.model.ui.liquidAmount = this.roundDecimals(liquid, 2);
  }

  public onChangeAmountDiscount(model: any, changes?: any) {
    // model = formElementComponent  -> _parent = AccountingDocumentModel

    if (changes.newValue == null) {
      changes.newValue = 0;
    }


    // Si se ha cargado la tabla a traves del buscador de facturas,
    // Cuando está provocado por un cambio en el importe de la factura no tenemos model._parent!!
    let modelParam: AccountingDocumentModel;
    if (model._parent) {
      modelParam = model._parent;
    } else if (this.model) {
      modelParam = this.model;
    }

    this.setAmountDiscount(modelParam);
  }

  private setAmountDiscount(model?: AccountingDocumentModel) {
    if (model === undefined || model === null) {
      model = this.model;
    }
    let importe = this.getTotalAmountDiscounts(model);
    this.model.ui.totalAmountDiscounts = importe;

    let liquid = this.model.ui.totalAmountInvoices - importe;
    this.model.ui.liquidAmount = this.roundDecimals(liquid, 2);
  }

  private roundDecimals(value: number, decimals?: number): number {
    // 555.31 + 955.62 = 1510.9299999999998
    let digits: number = (decimals || decimals === 0) ? decimals : 2;
    let multiplier = Math.pow(10, digits);
    return Math.round((value + Number.EPSILON) * multiplier) / multiplier;

  }

  private getTotalAmountBudget(model: AccountingDocumentModel) {
    // dto.budget.budgetAccountLine
    let total = 0;
    if (model.dto.budget && model.dto.budget.budgetAccountLine && model.dto.budget.budgetAccountLine.length > 0) {
      let budgetAccountLines = model.dto.budget.budgetAccountLine;
      for (let i in budgetAccountLines) {
        let totalAmount = budgetAccountLines[i].budget.totalAmount;
        if (totalAmount !== undefined && totalAmount != null) {
          total = total + totalAmount;
          total = this.roundDecimals(total, 2);
        }
      }
    }
    return total;
  }

  private getTotalAmountInvoices(model: AccountingDocumentModel) {
    //ui.budgetAccountLineInvoiceAssociates
    //ui.totalAmountInvoices

    let total = 0;
    if (model.ui.budgetAccountLineInvoiceAssociates && model.ui.budgetAccountLineInvoiceAssociates.length > 0) {
      let budgetAccountLineInvoiceAssociates = model.ui.budgetAccountLineInvoiceAssociates;
      for (let i in budgetAccountLineInvoiceAssociates) {
        let totalAmount = budgetAccountLineInvoiceAssociates[i].totalAmount;
        if (totalAmount !== undefined && totalAmount != null) {
          total = total + totalAmount;
          total = this.roundDecimals(total, 2);
        }
      }
    }
    return total;
  }

  private getTotalAmountDiscounts(model: AccountingDocumentModel) {
    // ui.budgetAccountLineInvoiceDiscountAssociates
    // ui.totalAmountDiscounts


    let total = 0;
    if (model.ui.budgetAccountLineInvoiceDiscountAssociates && model.ui.budgetAccountLineInvoiceDiscountAssociates.length > 0) {
      let budgetAccountLineInvoiceDiscountAssociates = model.ui.budgetAccountLineInvoiceDiscountAssociates;
      for (let i in budgetAccountLineInvoiceDiscountAssociates) {
        let totalAmount = budgetAccountLineInvoiceDiscountAssociates[i].totalAmount;
        if (totalAmount !== undefined && totalAmount != null) {
          total = total + totalAmount;
          total = this.roundDecimals(total, 2);
        }
      }
    }
    return total;
  }


  // -------------------------------------------------------------------------------------------------------------------

  public showAttachFiles(row: any) { // model = formElementComponent  -> _parent = AccountingDocumentModel
    console.log(row);

    let isAttachFile = '1';
    if (row?.invoice?.invoiceExternalFiles?.length > 1) {
      let config: DynamicDialogConfig = {
        header: 'Seleccionar el anexo a visualizar.',
        width: '60%',
        style: { 'max-height': '60%' },
        styleClass: 'searchStyle'
      };

      let context = {};

      context['files'] = row.invoice.invoiceExternalFiles;
      config['context'] = context;


      this.waitService.startWaiting();

      const refDialog = this.dialogService.open(
        DocumentFilesListComponent,
        config
      );


      refDialog.onClose.pipe(take(1)).subscribe(result => {
        if (result) {
          this.waitService.startWaiting();
          this.openFile(row, result, isAttachFile);
        } else {
          console.log('dialog cancelado');
        }
      });
    } else if (row?.invoice?.invoiceExternalFiles?.length == 1) {
      // Solo hay una plantilla, se genera directamente
      this.waitService.startWaiting();
      this.openFile(row, row?.invoice?.invoiceExternalFiles[0], isAttachFile);
    }
  }

  openFile(row: any, file: any, isAttachFile: string) {


    this.waitService.startWaiting('Recuperando fichero....');
    /*
    action.parameters.find((a) => a.name == 'documentumId').value = file.externalDocumentIdentifier ?
    file.externalDocumentIdentifier :
    file.externalIdentifier;
  action.parameters.find((a) => a.name == 'PROPUESTAID').value = row.invoice.division.project.identifier
  action.parameters.find((a) => a.name == 'LISTADOCID').value = row.invoice.documentClass.identifier;
  action.parameters.find((a) => a.name == 'LOTEID').value = getSimpleIdentifierFromString(row.invoice.division.identifier);
  //action.parameters.find((a) => a.name == 'NUMORDEN').value = false;
  //action.parameters.find((a) => a.name == 'link').value = '1';
  action.parameters.find((a) => a.name == 'isElectronic').value = row.invoice?.electronicInvoice;
  */

    let params = 'TARGET=' + this.userService.getUserId();
    let value = file.externalDocumentIdentifier ?
      file.externalDocumentIdentifier :
      file.externalIdentifier;
    params += '&documentumId=' + value;
    params += '&PROPUESTAID=' + row.invoice.division.project.identifier;
    params += '&LISTADOCID=' + row.invoice.documentClass.identifier;
    params += '&LOTEID=' + getSimpleIdentifierFromString(row.invoice.division.identifier);
    if (row.invoice?.orderNumber) {
      params += '&NUMORDEN=' + row.invoice.orderNumber;
    }
    value = row.invoice?.electronicInvoice ? '1' : '0';
    params += '&isElectronic=' + value;

    value = row.invoice?.certifiedDigitization ? '1' : '0';
    params += '&isCertifiedDigitization=' + value;

    params += '&isAttachFile=' + isAttachFile;

    this.subscribe(

      this.plycaService.runActionByName('DOCUMENTUM_DOWNLOAD', params).pipe(
        tap((result: ActionResultDTO) => {
          this.waitService.cancelWaiting();
          console.log('Acción ejecutada: ', result);
          if (result.identifier === 'OK') {
            if (result.file) {
              this.uiService.showSuccess(
                this.translate.instant('Actions.exec.ok'),
                this.translate.instant('General.info'),
                'success'
              );
              if (result?.file?.showFileOnDownload) {
                this.documentService.viewFile(result.file);
              }
            }

          } else {
            let message = this.translate.instant('General.errorMessage');
            if (result.description) {
              message = result.description;
            }
            this.uiService.showMessage(message, 'Error', 'errorStyle');
          }
        }),
        catchError((error: any) => {
          this.plycaErrorHandler.showServerError(error);
          return throwError(error);
        })
      ));
  }

  public isLoaded(): boolean {
    return this.botoneraLoaded;
  }
}
//  protected setTaskReference(modifiedDto: any) {
/*if (this.task) {
  // en el caso de tareas con recursos se envía la referencia a la tarea
  // para que el servidor obtenga las variables de contexto de la misma
  modifiedDto.task = {} as TaskDTO;
  modifiedDto.task.identifier = this.task.identifier;
}*/

//  console.log('======setTaskReference======================================================================================================================');
//}
